export default {
    zh: {
        // SEO Meta
        pageTitle: 'Qwen Image AI 图像生成器 - 免费文本转图像',
        pageDescription: '由阿里巴巴推出的 Qwen Image 是一款基础性的开源 AI 模型，擅长生成和编辑具有风格的图像，并且在复杂文本融合方面表现出色。在WeryAI 图像生成器中免费试用 Qwen Image！',
        pageKeywords: 'Qwen Image, 阿里巴巴, AI 图像生成, AI 绘画, 人工智能, 图像编辑, 创意表达',

        // Open Graph
        ogTitle: 'Qwen Image AI 图像生成器 - 免费文本转图像',
        ogDescription: '由阿里巴巴推出的 Qwen Image 是一款基础性的开源 AI 模型，擅长生成和编辑具有风格的图像，并且在复杂文本融合方面表现出色。',

        // Twitter Card
        twitterTitle: 'Qwen Image AI 图像生成器 - 免费文本转图像',
        twitterDescription: '由阿里巴巴推出的 Qwen Image 擅长生成和编辑具有风格的图像，在复杂文本融合方面表现出色。',

        // Generator Section
        generatorTitle: 'Qwen Image AI 图像生成器',
        generatorSubtitle: '由阿里巴巴推出的 Qwen Image 是一款基础性的开源 AI 模型，擅长生成和编辑具有风格的图像，并且在复杂文本融合方面表现出色。在WeryAI 图像生成器中免费试用 Qwen Image！',

        // Core Features Section
        coreFeaturesTitle: 'Qwen Image 核心功能特性',
        coreFeaturesSubtitle: '探索 Qwen Image AI 图像生成器的核心功能，开启革命性的 AI 图像创作之旅',

        // Features
        diverseImageTitle: '多样化图像生成',
        diverseImageDesc: '创作各种风格的生动图像。Qwen Image 能够生成具有专业级质量的图像，支持多种艺术风格和创意表达，让您的创意无限延伸。',
        diverseImageAlt: '多样化图像生成示例',

        intuitiveEditingTitle: '直观图像编辑',
        intuitiveEditingDesc: '支持使用日常语言进行专业级编辑。通过简单的文字描述，您可以精确调整图像的细节、颜色、风格和构图，无需复杂的操作。',
        intuitiveEditingAlt: '直观图像编辑示例',

        fineTextRenderingTitle: '精细化文本渲染',
        fineTextRenderingDesc: '将多语言文本无缝集成到图像中。支持各种语言的文字渲染，确保文本与图像完美融合，创造出专业的视觉效果。',
        fineTextRenderingAlt: '精细化文本渲染示例',

        smartPromptTitle: '智能提示遵循',
        smartPromptDesc: '具备深度视觉理解能力，以实现创意指令。智能分析您的需求，精准理解创意意图，生成符合预期的高质量图像。',
        smartPromptAlt: '智能提示遵循示例',

        // How to Use Section
        howToUseTitle: '如何使用',
        howToUseSubtitle: '简单三步，开始创作',

        step1Title: '选择模型',
        step1Description: '在 AI 图像工具中选择 Qwen Image 模型',

        step2Title: '输入内容',
        step2Description: '输入提示词或上传参考图像',

        step3Title: '生成图像',
        step3Description: '点击生成按钮，等待并下载您的图像',

        // YouTube Videos Section
        youtubeTitle: '关于 Qwen Image AI 图像模型的 YouTube 视频',

        // X Posts Section
        xPostsTitle: '关于 Qwen Image AI 图像模型的 X 帖子',

        // Explore Other Models Section
        exploreModelsTitle: '在 微鲤AI 上探索其他 AI 图像模型',
        model1Title: 'Google Nano Banana AI Image Generator',
        model2Title: 'FLUX AI Image Generator',
        model3Title: 'Google Imagen AI Image Generator',

        // FAQ Section
        faqTitle: '常见问题解答',

        faq1Question: '什么是 Qwen Image?',
        faq1Answer: 'Qwen Image 是阿里巴巴开发的开源 AI 图像生成模型，具备卓越的图像质量和创意表达能力，能够生成具有专业级质量的图像。',

        faq2Question: 'Qwen Image 与其他图像生成模型相比有哪些优势?',
        faq2Answer: 'Qwen Image 在图像质量、创意表达、风格控制和文本渲染方面具有显著优势。它能够生成高质量的专业级图像，并支持复杂的文本融合。',

        faq3Question: '我能免费使用 Qwen Image 吗?',
        faq3Answer: '是的。Qwen Image 通过 微鲤AI 的免费试用提供有限的免费额度。如需大量使用,则需要升级。',

        faq4Question: 'Qwen Image 支持哪些图像格式?',
        faq4Answer: 'Qwen Image 支持多种图像格式，包括 JPG、PNG、WEBP 等常见格式。生成的图像具有高质量和丰富的细节表现。',

        faq5Question: '我可以使用 Qwen Image 用于商业项目吗?',
        faq5Answer: '是的。Qwen Image 的高精度图像生成和创意表达能力使其成为设计师、艺术家和内容创作者寻求高质量 AI 生成图像的有力选择。',

        // CTA Section
        ctaTitle: '准备开始创作了吗？',
        ctaDescription: '立即体验 Qwen Image，将您的创意转化为精彩图像',
        ctaButton: 'Try Qwen Image on 微鲤AI',
        ctaDisclaimer: 'No credit card required',
    },
    en: {
        // SEO Meta
        pageTitle: 'Qwen Image AI Image Generator - Free Text to Image',
        pageDescription: 'Qwen Image by Alibaba is a foundational open-source AI model that excels at generating and editing stylized images with outstanding complex text integration. Try Qwen Image for free on 微鲤AI image generator!',
        pageKeywords: 'Qwen Image, Alibaba, AI image generation, AI art, artificial intelligence, image editing, creative expression',

        // Open Graph
        ogTitle: 'Qwen Image AI Image Generator - Free Text to Image',
        ogDescription: 'Qwen Image by Alibaba is a foundational open-source AI model that excels at generating and editing stylized images with outstanding complex text integration.',

        // Twitter Card
        twitterTitle: 'Qwen Image AI Image Generator - Free Text to Image',
        twitterDescription: 'Qwen Image by Alibaba excels at generating and editing stylized images with outstanding complex text integration.',

        // Generator Section
        generatorTitle: 'Qwen Image AI Image Generator',
        generatorSubtitle: 'Qwen Image by Alibaba is a foundational open-source AI model that excels at generating and editing stylized images with outstanding complex text integration. Try Qwen Image for free on 微鲤AI image generator!',

        // Core Features Section
        coreFeaturesTitle: 'Qwen Image Core Features',
        coreFeaturesSubtitle: 'Explore the core features of Qwen Image AI image generator and embark on a revolutionary AI image creation journey',

        // Features
        diverseImageTitle: 'Diverse Image Generation',
        diverseImageDesc: 'Create vivid images in various styles. Qwen Image generates professional-quality images supporting multiple artistic styles and creative expression, extending your creativity infinitely.',
        diverseImageAlt: 'Diverse Image Generation Example',

        intuitiveEditingTitle: 'Intuitive Image Editing',
        intuitiveEditingDesc: 'Supports professional-level editing using everyday language. Through simple text descriptions, you can precisely adjust image details, colors, styles, and composition without complex operations.',
        intuitiveEditingAlt: 'Intuitive Image Editing Example',

        fineTextRenderingTitle: 'Fine-grained Text Rendering',
        fineTextRenderingDesc: 'Seamlessly integrate multilingual text into images. Supports text rendering in various languages, ensuring perfect fusion of text and images to create professional visual effects.',
        fineTextRenderingAlt: 'Fine-grained Text Rendering Example',

        smartPromptTitle: 'Smart Prompt Following',
        smartPromptDesc: 'Possesses deep visual understanding to realize creative instructions. Intelligently analyzes your needs, precisely understands creative intent, and generates high-quality images that meet expectations.',
        smartPromptAlt: 'Smart Prompt Following Example',

        // How to Use Section
        howToUseTitle: 'How to Use',
        howToUseSubtitle: 'Three simple steps to start creating',

        step1Title: 'Select Model',
        step1Description: 'Choose Qwen Image model in AI image tools',

        step2Title: 'Input Content',
        step2Description: 'Enter prompts or upload reference images',

        step3Title: 'Generate Image',
        step3Description: 'Click generate button, wait and download your image',

        // YouTube Videos Section
        youtubeTitle: 'YouTube Videos About Qwen Image AI Model',

        // X Posts Section
        xPostsTitle: 'X Posts About Qwen Image AI Model',

        // Explore Other Models Section
        exploreModelsTitle: 'Explore Other AI Image Models on 微鲤AI',
        model1Title: 'Google Nano Banana AI Image Generator',
        model2Title: 'FLUX AI Image Generator',
        model3Title: 'Google Imagen AI Image Generator',

        // FAQ Section
        faqTitle: 'Frequently Asked Questions',

        faq1Question: 'What is Qwen Image?',
        faq1Answer: 'Qwen Image is an open-source AI image generation model developed by Alibaba, featuring exceptional image quality and creative expression capabilities that can generate professional-grade images.',

        faq2Question: 'What advantages does Qwen Image have over other image generation models?',
        faq2Answer: 'Qwen Image has significant advantages in image quality, creative expression, style control, and text rendering. It can generate high-quality professional-grade images and supports complex text integration.',

        faq3Question: 'Can I use Qwen Image for free?',
        faq3Answer: 'Yes. Qwen Image offers limited free credits through 微鲤AI\'s free trial. For extensive use, an upgrade is required.',

        faq4Question: 'What image formats does Qwen Image support?',
        faq4Answer: 'Qwen Image supports various image formats including JPG, PNG, WEBP and other common formats. Generated images feature high quality and rich detail.',

        faq5Question: 'Can I use Qwen Image for commercial projects?',
        faq5Answer: 'Yes. Qwen Image\'s high-precision image generation and creative expression capabilities make it a powerful choice for designers, artists, and content creators seeking high-quality AI-generated images.',

        // CTA Section
        ctaTitle: 'Ready to Start Creating?',
        ctaDescription: 'Experience Qwen Image now and transform your ideas into amazing images',
        ctaButton: 'Try Qwen Image on 微鲤AI',
        ctaDisclaimer: 'No credit card required',
    },
    ja: {
        // 日语翻译
        pageTitle: 'Qwen Image AI画像ジェネレーター - 無料のテキストから画像へ',
        pageDescription: 'AlibabaのQwen Imageは、優れた複雑なテキスト統合を備えたスタイライズ画像の生成と編集に優れた基盤的なオープンソースAIモデルです。WeryAI画像ジェネレーターで無料でQwen Imageをお試しください！',
        pageKeywords: 'Qwen Image, Alibaba, AI画像生成, AIアート, 人工知能, 画像編集, クリエイティブ表現',
        ogTitle: 'Qwen Image AI画像ジェネレーター - 無料のテキストから画像へ',
        ogDescription: 'AlibabaのQwen Imageは、優れた複雑なテキスト統合を備えたスタイライズ画像の生成と編集に優れた基盤的なオープンソースAIモデルです。',
        twitterTitle: 'Qwen Image AI画像ジェネレーター - 無料のテキストから画像へ',
        twitterDescription: 'AlibabaのQwen Imageは、優れた複雑なテキスト統合を備えたスタイライズ画像の生成と編集に優れています。',
        generatorTitle: 'Qwen Image AI画像ジェネレーター',
        generatorSubtitle: 'AlibabaのQwen Imageは、優れた複雑なテキスト統合を備えたスタイライズ画像の生成と編集に優れた基盤的なオープンソースAIモデルです。WeryAI画像ジェネレーターで無料でQwen Imageをお試しください！',
        coreFeaturesTitle: 'Qwen Imageの主な機能',
        coreFeaturesSubtitle: 'Qwen Image AI画像ジェネレーターの主な機能を探索し、革新的なAI画像作成の旅に出ましょう',
        diverseImageTitle: '多様な画像生成',
        diverseImageDesc: '様々なスタイルで鮮やかな画像を作成します。Qwen Imageは、複数の芸術スタイルとクリエイティブ表現をサポートするプロフェッショナル品質の画像を生成し、あなたの創造性を無限に広げます。',
        diverseImageAlt: '多様な画像生成の例',
        intuitiveEditingTitle: '直感的な画像編集',
        intuitiveEditingDesc: '日常言語を使用したプロフェッショナルレベルの編集をサポートします。簡単なテキスト説明を通じて、複雑な操作なしで画像の詳細、色、スタイル、構図を正確に調整できます。',
        intuitiveEditingAlt: '直感的な画像編集の例',
        fineTextRenderingTitle: 'きめ細かなテキストレンダリング',
        fineTextRenderingDesc: '多言語テキストを画像にシームレスに統合します。様々な言語でのテキストレンダリングをサポートし、テキストと画像の完璧な融合を確保してプロフェッショナルな視覚効果を作成します。',
        fineTextRenderingAlt: 'きめ細かなテキストレンダリングの例',
        smartPromptTitle: 'スマートプロンプトフォローイング',
        smartPromptDesc: '深い視覚理解を持ち、クリエイティブな指示を実現します。あなたのニーズを賢く分析し、クリエイティブな意図を正確に理解し、期待に応える高品質な画像を生成します。',
        smartPromptAlt: 'スマートプロンプトフォローイングの例',
        howToUseTitle: '使い方',
        howToUseSubtitle: '簡単3ステップで開始',
        step1Title: 'モデルを選択',
        step1Description: 'AI画像ツールでQwen Imageモデルを選択',
        step2Title: 'コンテンツを入力',
        step2Description: 'プロンプトを入力または参照画像をアップロード',
        step3Title: '画像を生成',
        step3Description: '生成ボタンをクリックし、待機して画像をダウンロード',
        youtubeTitle: 'Qwen Image AIモデルについてのYouTube動画',
        xPostsTitle: 'Qwen Image AIモデルについてのX投稿',
        exploreModelsTitle: 'WeryAIで他のAI画像モデルを探索',
        model1Title: 'Google Nano Banana AI画像ジェネレーター',
        model2Title: 'FLUX AI画像ジェネレーター',
        model3Title: 'Google Imagen AI画像ジェネレーター',
        faqTitle: 'よくある質問',
        faq1Question: 'Qwen Imageとは何ですか？',
        faq1Answer: 'Qwen Imageは、Alibabaが開発したオープンソースのAI画像生成モデルで、プロフェッショナルグレードの画像を生成できる卓越した画像品質とクリエイティブ表現機能を備えています。',
        faq2Question: 'Qwen Imageは他の画像生成モデルと比べてどのような利点がありますか？',
        faq2Answer: 'Qwen Imageは、画像品質、クリエイティブ表現、スタイルコントロール、テキストレンダリングにおいて大きな利点があります。高品質なプロフェッショナルグレードの画像を生成でき、複雑なテキスト統合をサポートします。',
        faq3Question: 'Qwen Imageを無料で使用できますか？',
        faq3Answer: 'はい。Qwen ImageはWeryAIの無料トライアルを通じて限定的な無料クレジットを提供しています。大量使用の場合はアップグレードが必要です。',
        faq4Question: 'Qwen Imageはどのような画像形式をサポートしていますか？',
        faq4Answer: 'Qwen ImageはJPG、PNG、WEBPなどの一般的な形式を含む様々な画像形式をサポートしています。生成された画像は高品質で豊富な詳細を特徴としています。',
        faq5Question: 'Qwen Imageを商業プロジェクトに使用できますか？',
        faq5Answer: 'はい。Qwen Imageの高精度画像生成とクリエイティブ表現機能は、高品質なAI生成画像を求めるデザイナー、アーティスト、コンテンツクリエーターにとって強力な選択肢となります。',
        ctaTitle: '作成を始める準備はできましたか？',
        ctaDescription: '今すぐQwen Imageを体験し、あなたのアイデアを素晴らしい画像に変換',
        ctaButton: 'Try Qwen Image on 微鲤AI',
        ctaDisclaimer: 'No credit card required',
    },
    ko: {
        // 韩语翻译
        pageTitle: 'Qwen Image AI 이미지 생성기 - 무료 텍스트에서 이미지로',
        pageDescription: 'Alibaba의 Qwen Image는 뛰어난 복잡한 텍스트 통합으로 스타일화된 이미지를 생성하고 편집하는 데 탁월한 기본 오픈소스 AI 모델입니다. 微鲤AI 이미지 생성기에서 무료로 Qwen Image를 체험하세요!',
        pageKeywords: 'Qwen Image, Alibaba, AI 이미지 생성, AI 아트, 인공지능, 이미지 편집, 창의적 표현',
        ogTitle: 'Qwen Image AI 이미지 생성기 - 무료 텍스트에서 이미지로',
        ogDescription: 'Alibaba의 Qwen Image는 뛰어난 복잡한 텍스트 통합으로 스타일화된 이미지를 생성하고 편집하는 데 탁월한 기본 오픈소스 AI 모델입니다.',
        twitterTitle: 'Qwen Image AI 이미지 생성기 - 무료 텍스트에서 이미지로',
        twitterDescription: 'Alibaba의 Qwen Image는 뛰어난 복잡한 텍스트 통합으로 스타일화된 이미지를 생성하고 편집하는 데 탁월합니다.',
        generatorTitle: 'Qwen Image AI 이미지 생성기',
        generatorSubtitle: 'Alibaba의 Qwen Image는 뛰어난 복잡한 텍스트 통합으로 스타일화된 이미지를 생성하고 편집하는 데 탁월한 기본 오픈소스 AI 모델입니다. 微鲤AI 이미지 생성기에서 무료로 Qwen Image를 체험하세요!',
        coreFeaturesTitle: 'Qwen Image의 주요 기능',
        coreFeaturesSubtitle: 'Qwen Image AI 이미지 생성기의 주요 기능을 탐색하고 혁신적인 AI 이미지 제작 여정을 시작하세요',
        diverseImageTitle: '다양한 이미지 생성',
        diverseImageDesc: '다양한 스타일로 생생한 이미지를 만듭니다. Qwen Image는 여러 예술 스타일과 창의적 표현을 지원하는 전문가급 품질의 이미지를 생성하여 창의성을 무한히 확장합니다.',
        diverseImageAlt: '다양한 이미지 생성 예시',
        intuitiveEditingTitle: '직관적인 이미지 편집',
        intuitiveEditingDesc: '일상 언어를 사용한 전문가 수준의 편집을 지원합니다. 간단한 텍스트 설명을 통해 복잡한 작업 없이 이미지 세부사항, 색상, 스타일, 구성을 정확하게 조정할 수 있습니다.',
        intuitiveEditingAlt: '직관적인 이미지 편집 예시',
        fineTextRenderingTitle: '세밀한 텍스트 렌더링',
        fineTextRenderingDesc: '다국어 텍스트를 이미지에 원활하게 통합합니다. 다양한 언어로 텍스트 렌더링을 지원하여 텍스트와 이미지의 완벽한 융합을 보장하고 전문적인 시각 효과를 만듭니다.',
        fineTextRenderingAlt: '세밀한 텍스트 렌더링 예시',
        smartPromptTitle: '스마트 프롬프트 추종',
        smartPromptDesc: '깊은 시각적 이해를 가지고 창의적인 지시를 실현합니다. 당신의 요구를 지능적으로 분석하고 창의적 의도를 정확하게 이해하며 기대에 부응하는 고품질 이미지를 생성합니다.',
        smartPromptAlt: '스마트 프롬프트 추종 예시',
        howToUseTitle: '사용 방법',
        howToUseSubtitle: '간단한 3단계로 시작',
        step1Title: '모델 선택',
        step1Description: 'AI 이미지 도구에서 Qwen Image 모델 선택',
        step2Title: '콘텐츠 입력',
        step2Description: '프롬프트 입력 또는 참조 이미지 업로드',
        step3Title: '이미지 생성',
        step3Description: '생성 버튼 클릭, 대기 후 이미지 다운로드',
        youtubeTitle: 'Qwen Image AI 모델에 대한 YouTube 비디오',
        xPostsTitle: 'Qwen Image AI 모델에 대한 X 게시물',
        exploreModelsTitle: 'WeryAI에서 다른 AI 이미지 모델 탐색',
        model1Title: 'Google Nano Banana AI 이미지 생성기',
        model2Title: 'FLUX AI 이미지 생성기',
        model3Title: 'Google Imagen AI 이미지 생성기',
        faqTitle: '자주 묻는 질문',
        faq1Question: 'Qwen Image가 무엇인가요?',
        faq1Answer: 'Qwen Image는 Alibaba에서 개발한 오픈소스 AI 이미지 생성 모델로, 전문가급 이미지를 생성할 수 있는 탁월한 이미지 품질과 창의적 표현 기능을 갖추고 있습니다.',
        faq2Question: 'Qwen Image는 다른 이미지 생성 모델에 비해 어떤 장점이 있나요?',
        faq2Answer: 'Qwen Image는 이미지 품질, 창의적 표현, 스타일 제어, 텍스트 렌더링에서 큰 장점이 있습니다. 고품질의 전문가급 이미지를 생성할 수 있으며 복잡한 텍스트 통합을 지원합니다.',
        faq3Question: 'Qwen Image를 무료로 사용할 수 있나요?',
        faq3Answer: '네. Qwen Image는 WeryAI의 무료 체험을 통해 제한된 무료 크레딧을 제공합니다. 광범위한 사용을 위해서는 업그레이드가 필요합니다.',
        faq4Question: 'Qwen Image는 어떤 이미지 형식을 지원하나요?',
        faq4Answer: 'Qwen Image는 JPG, PNG, WEBP 등 일반적인 형식을 포함한 다양한 이미지 형식을 지원합니다. 생성된 이미지는 고품질과 풍부한 디테일을 특징으로 합니다.',
        faq5Question: 'Qwen Image를 상업 프로젝트에 사용할 수 있나요?',
        faq5Answer: '네. Qwen Image의 고정밀 이미지 생성과 창의적 표현 기능은 고품질 AI 생성 이미지를 찾는 디자이너, 아티스트, 콘텐츠 크리에이터에게 강력한 선택이 됩니다.',
        ctaTitle: '제작을 시작할 준비가 되셨나요?',
        ctaDescription: '지금 Qwen Image를 체험하고 당신의 아이디어를 놀라운 이미지로 변환하세요',
        ctaButton: 'Try Qwen Image on 微鲤AI',
        ctaDisclaimer: 'No credit card required',
    },
    tw: {

        // SEO Meta
        pageTitle: 'Qwen Image AI 图像生成器 - 免费文本转图像',
        pageDescription: '由阿里巴巴推出的 Qwen Image 是一款基础性的开源 AI 模型，擅长生成和编辑具有风格的图像，并且在复杂文本融合方面表现出色。在WeryAI 图像生成器中免费试用 Qwen Image！',
        pageKeywords: 'Qwen Image, 阿里巴巴, AI 图像生成, AI 绘画, 人工智能, 图像编辑, 创意表达',

        // Open Graph
        ogTitle: 'Qwen Image AI 图像生成器 - 免费文本转图像',
        ogDescription: '由阿里巴巴推出的 Qwen Image 是一款基础性的开源 AI 模型，擅长生成和编辑具有风格的图像，并且在复杂文本融合方面表现出色。',

        // Twitter Card
        twitterTitle: 'Qwen Image AI 图像生成器 - 免费文本转图像',
        twitterDescription: '由阿里巴巴推出的 Qwen Image 擅长生成和编辑具有风格的图像，在复杂文本融合方面表现出色。',

        // Generator Section
        generatorTitle: 'Qwen Image AI 图像生成器',
        generatorSubtitle: '由阿里巴巴推出的 Qwen Image 是一款基础性的开源 AI 模型，擅长生成和编辑具有风格的图像，并且在复杂文本融合方面表现出色。在WeryAI 图像生成器中免费试用 Qwen Image！',

        // Core Features Section
        coreFeaturesTitle: 'Qwen Image 核心功能特性',
        coreFeaturesSubtitle: '探索 Qwen Image AI 图像生成器的核心功能，开启革命性的 AI 图像创作之旅',

        // Features
        diverseImageTitle: '多样化图像生成',
        diverseImageDesc: '创作各种风格的生动图像。Qwen Image 能够生成具有专业级质量的图像，支持多种艺术风格和创意表达，让您的创意无限延伸。',
        diverseImageAlt: '多样化图像生成示例',

        intuitiveEditingTitle: '直观图像编辑',
        intuitiveEditingDesc: '支持使用日常语言进行专业级编辑。通过简单的文字描述，您可以精确调整图像的细节、颜色、风格和构图，无需复杂的操作。',
        intuitiveEditingAlt: '直观图像编辑示例',

        fineTextRenderingTitle: '精细化文本渲染',
        fineTextRenderingDesc: '将多语言文本无缝集成到图像中。支持各种语言的文字渲染，确保文本与图像完美融合，创造出专业的视觉效果。',
        fineTextRenderingAlt: '精细化文本渲染示例',

        smartPromptTitle: '智能提示遵循',
        smartPromptDesc: '具备深度视觉理解能力，以实现创意指令。智能分析您的需求，精准理解创意意图，生成符合预期的高质量图像。',
        smartPromptAlt: '智能提示遵循示例',

        // How to Use Section
        howToUseTitle: '如何使用',
        howToUseSubtitle: '简单三步，开始创作',

        step1Title: '选择模型',
        step1Description: '在 AI 图像工具中选择 Qwen Image 模型',

        step2Title: '输入内容',
        step2Description: '输入提示词或上传参考图像',

        step3Title: '生成图像',
        step3Description: '点击生成按钮，等待并下载您的图像',

        // YouTube Videos Section
        youtubeTitle: '关于 Qwen Image AI 图像模型的 YouTube 视频',

        // X Posts Section
        xPostsTitle: '关于 Qwen Image AI 图像模型的 X 帖子',

        // Explore Other Models Section
        exploreModelsTitle: '在 微鲤AI 上探索其他 AI 图像模型',
        model1Title: 'Google Nano Banana AI Image Generator',
        model2Title: 'FLUX AI Image Generator',
        model3Title: 'Google Imagen AI Image Generator',

        // FAQ Section
        faqTitle: '常见问题解答',

        faq1Question: '什么是 Qwen Image?',
        faq1Answer: 'Qwen Image 是阿里巴巴开发的开源 AI 图像生成模型，具备卓越的图像质量和创意表达能力，能够生成具有专业级质量的图像。',

        faq2Question: 'Qwen Image 与其他图像生成模型相比有哪些优势?',
        faq2Answer: 'Qwen Image 在图像质量、创意表达、风格控制和文本渲染方面具有显著优势。它能够生成高质量的专业级图像，并支持复杂的文本融合。',

        faq3Question: '我能免费使用 Qwen Image 吗?',
        faq3Answer: '是的。Qwen Image 通过 微鲤AI 的免费试用提供有限的免费额度。如需大量使用,则需要升级。',

        faq4Question: 'Qwen Image 支持哪些图像格式?',
        faq4Answer: 'Qwen Image 支持多种图像格式，包括 JPG、PNG、WEBP 等常见格式。生成的图像具有高质量和丰富的细节表现。',

        faq5Question: '我可以使用 Qwen Image 用于商业项目吗?',
        faq5Answer: '是的。Qwen Image 的高精度图像生成和创意表达能力使其成为设计师、艺术家和内容创作者寻求高质量 AI 生成图像的有力选择。',

        // CTA Section
        ctaTitle: '准备开始创作了吗？',
        ctaDescription: '立即体验 Qwen Image，将您的创意转化为精彩图像',
        ctaButton: 'Try Qwen Image on 微鲤AI',
        ctaDisclaimer: 'No credit card required',
    },
    pl: {

        // SEO Meta
        pageTitle: 'Qwen Image AI Image Generator - Free Text to Image',
        pageDescription: 'Qwen Image by Alibaba is a foundational open-source AI model that excels at generating and editing stylized images with outstanding complex text integration. Try Qwen Image for free on 微鲤AI image generator!',
        pageKeywords: 'Qwen Image, Alibaba, AI image generation, AI art, artificial intelligence, image editing, creative expression',

        // Open Graph
        ogTitle: 'Qwen Image AI Image Generator - Free Text to Image',
        ogDescription: 'Qwen Image by Alibaba is a foundational open-source AI model that excels at generating and editing stylized images with outstanding complex text integration.',

        // Twitter Card
        twitterTitle: 'Qwen Image AI Image Generator - Free Text to Image',
        twitterDescription: 'Qwen Image by Alibaba excels at generating and editing stylized images with outstanding complex text integration.',

        // Generator Section
        generatorTitle: 'Qwen Image AI Image Generator',
        generatorSubtitle: 'Qwen Image by Alibaba is a foundational open-source AI model that excels at generating and editing stylized images with outstanding complex text integration. Try Qwen Image for free on 微鲤AI image generator!',

        // Core Features Section
        coreFeaturesTitle: 'Qwen Image Core Features',
        coreFeaturesSubtitle: 'Explore the core features of Qwen Image AI image generator and embark on a revolutionary AI image creation journey',

        // Features
        diverseImageTitle: 'Diverse Image Generation',
        diverseImageDesc: 'Create vivid images in various styles. Qwen Image generates professional-quality images supporting multiple artistic styles and creative expression, extending your creativity infinitely.',
        diverseImageAlt: 'Diverse Image Generation Example',

        intuitiveEditingTitle: 'Intuitive Image Editing',
        intuitiveEditingDesc: 'Supports professional-level editing using everyday language. Through simple text descriptions, you can precisely adjust image details, colors, styles, and composition without complex operations.',
        intuitiveEditingAlt: 'Intuitive Image Editing Example',

        fineTextRenderingTitle: 'Fine-grained Text Rendering',
        fineTextRenderingDesc: 'Seamlessly integrate multilingual text into images. Supports text rendering in various languages, ensuring perfect fusion of text and images to create professional visual effects.',
        fineTextRenderingAlt: 'Fine-grained Text Rendering Example',

        smartPromptTitle: 'Smart Prompt Following',
        smartPromptDesc: 'Possesses deep visual understanding to realize creative instructions. Intelligently analyzes your needs, precisely understands creative intent, and generates high-quality images that meet expectations.',
        smartPromptAlt: 'Smart Prompt Following Example',

        // How to Use Section
        howToUseTitle: 'How to Use',
        howToUseSubtitle: 'Three simple steps to start creating',

        step1Title: 'Select Model',
        step1Description: 'Choose Qwen Image model in AI image tools',

        step2Title: 'Input Content',
        step2Description: 'Enter prompts or upload reference images',

        step3Title: 'Generate Image',
        step3Description: 'Click generate button, wait and download your image',

        // YouTube Videos Section
        youtubeTitle: 'YouTube Videos About Qwen Image AI Model',

        // X Posts Section
        xPostsTitle: 'X Posts About Qwen Image AI Model',

        // Explore Other Models Section
        exploreModelsTitle: 'Explore Other AI Image Models on 微鲤AI',
        model1Title: 'Google Nano Banana AI Image Generator',
        model2Title: 'FLUX AI Image Generator',
        model3Title: 'Google Imagen AI Image Generator',

        // FAQ Section
        faqTitle: 'Frequently Asked Questions',

        faq1Question: 'What is Qwen Image?',
        faq1Answer: 'Qwen Image is an open-source AI image generation model developed by Alibaba, featuring exceptional image quality and creative expression capabilities that can generate professional-grade images.',

        faq2Question: 'What advantages does Qwen Image have over other image generation models?',
        faq2Answer: 'Qwen Image has significant advantages in image quality, creative expression, style control, and text rendering. It can generate high-quality professional-grade images and supports complex text integration.',

        faq3Question: 'Can I use Qwen Image for free?',
        faq3Answer: 'Yes. Qwen Image offers limited free credits through 微鲤AI\'s free trial. For extensive use, an upgrade is required.',

        faq4Question: 'What image formats does Qwen Image support?',
        faq4Answer: 'Qwen Image supports various image formats including JPG, PNG, WEBP and other common formats. Generated images feature high quality and rich detail.',

        faq5Question: 'Can I use Qwen Image for commercial projects?',
        faq5Answer: 'Yes. Qwen Image\'s high-precision image generation and creative expression capabilities make it a powerful choice for designers, artists, and content creators seeking high-quality AI-generated images.',

        // CTA Section
        ctaTitle: 'Ready to Start Creating?',
        ctaDescription: 'Experience Qwen Image now and transform your ideas into amazing images',
        ctaButton: 'Try Qwen Image on 微鲤AI',
        ctaDisclaimer: 'No credit card required',
    },
    es: {
        // SEO Meta
        pageTitle: 'Generador de Imágenes IA Qwen Image - Texto a Imagen Gratis',
        pageDescription: 'Qwen Image de Alibaba es un modelo IA de código abierto fundamental que sobresale en generar y editar imágenes estilizadas con una integración de texto complejo excepcional. ¡Prueba Qwen Image gratis en el generador de imágenes 微鲤AI!',
        pageKeywords: 'Qwen Image, Alibaba, generación de imágenes IA, arte IA, inteligencia artificial, edición de imágenes, expresión creativa',
    
        // Open Graph
        ogTitle: 'Generador de Imágenes IA Qwen Image - Texto a Imagen Gratis',
        ogDescription: 'Qwen Image de Alibaba es un modelo IA de código abierto fundamental que sobresale en generar y editar imágenes estilizadas con una integración de texto complejo excepcional.',
    
        // Twitter Card
        twitterTitle: 'Generador de Imágenes IA Qwen Image - Texto a Imagen Gratis',
        twitterDescription: 'Qwen Image de Alibaba sobresale en generar y editar imágenes estilizadas con una integración de texto complejo excepcional.',
    
        // Generator Section
        generatorTitle: 'Generador de Imágenes IA Qwen Image',
        generatorSubtitle: 'Qwen Image de Alibaba es un modelo IA de código abierto fundamental que sobresale en generar y editar imágenes estilizadas con una integración de texto complejo excepcional. ¡Prueba Qwen Image gratis en el generador de imágenes 微鲤AI!',
    
        // Core Features Section
        coreFeaturesTitle: 'Características Principales de Qwen Image',
        coreFeaturesSubtitle: 'Explora las características principales del generador de imágenes IA Qwen Image y embárcate en un viaje revolucionario de creación de imágenes IA',
    
        // Features
        diverseImageTitle: 'Generación de Imágenes Diversas',
        diverseImageDesc: 'Crea imágenes vívidas en varios estilos. Qwen Image genera imágenes de calidad profesional que soportan múltiples estilos artísticos y expresión creativa, extendiendo tu creatividad infinitamente.',
        diverseImageAlt: 'Ejemplo de Generación de Imágenes Diversas',
    
        intuitiveEditingTitle: 'Edición de Imágenes Intuitiva',
        intuitiveEditingDesc: 'Soporta edición de nivel profesional usando lenguaje cotidiano. A través de descripciones de texto simples, puedes ajustar con precisión detalles, colores, estilos y composición de imágenes sin operaciones complejas.',
        intuitiveEditingAlt: 'Ejemplo de Edición de Imágenes Intuitiva',
    
        fineTextRenderingTitle: 'Renderizado de Texto de Grano Fino',
        fineTextRenderingDesc: 'Integra sin problemas texto multilingüe en las imágenes. Soporta renderizado de texto en varios idiomas, asegurando una fusión perfecta de texto e imágenes para crear efectos visuales profesionales.',
        fineTextRenderingAlt: 'Ejemplo de Renderizado de Texto de Grano Fino',
    
        smartPromptTitle: 'Seguimiento Inteligente de Prompts',
        smartPromptDesc: 'Posee comprensión visual profunda para realizar instrucciones creativas. Analiza inteligentemente tus necesidades, comprende con precisión la intención creativa y genera imágenes de alta calidad que cumplen las expectativas.',
        smartPromptAlt: 'Ejemplo de Seguimiento Inteligente de Prompts',
    
        // How to Use Section
        howToUseTitle: 'Cómo Usar',
        howToUseSubtitle: 'Tres simples pasos para comenzar a crear',
    
        step1Title: 'Seleccionar Modelo',
        step1Description: 'Elige el modelo Qwen Image en las herramientas de imagen IA',
    
        step2Title: 'Ingresar Contenido',
        step2Description: 'Introduce prompts o sube imágenes de referencia',
    
        step3Title: 'Generar Imagen',
        step3Description: 'Haz clic en el botón generar, espera y descarga tu imagen',
    
        // YouTube Videos Section
        youtubeTitle: 'Videos de YouTube sobre el Modelo IA Qwen Image',
    
        // X Posts Section
        xPostsTitle: 'Publicaciones de X sobre el Modelo IA Qwen Image',
    
        // Explore Other Models Section
        exploreModelsTitle: 'Explora Otros Modelos de Imagen IA en 微鲤AI',
        model1Title: 'Generador de Imágenes IA Google Nano Banana',
        model2Title: 'Generador de Imágenes IA FLUX',
        model3Title: 'Generador de Imágenes IA Google Imagen',
    
        // FAQ Section
        faqTitle: 'Preguntas Frecuentes',
    
        faq1Question: '¿Qué es Qwen Image?',
        faq1Answer: 'Qwen Image es un modelo de generación de imágenes IA de código abierto desarrollado por Alibaba, con calidad de imagen excepcional y capacidades de expresión creativa que pueden generar imágenes de grado profesional.',
    
        faq2Question: '¿Qué ventajas tiene Qwen Image sobre otros modelos de generación de imágenes?',
        faq2Answer: 'Qwen Image tiene ventajas significativas en calidad de imagen, expresión creativa, control de estilo y renderizado de texto. Puede generar imágenes de grado profesional de alta calidad y soporta integración de texto complejo.',
    
        faq3Question: '¿Puedo usar Qwen Image gratis?',
        faq3Answer: 'Sí. Qwen Image ofrece créditos gratuitos limitados a través de la prueba gratuita de 微鲤AI. Para uso extensivo, se requiere una actualización.',
    
        faq4Question: '¿Qué formatos de imagen soporta Qwen Image?',
        faq4Answer: 'Qwen Image soporta varios formatos de imagen incluyendo JPG, PNG, WEBP y otros formatos comunes. Las imágenes generadas presentan alta calidad y detalles ricos.',
    
        faq5Question: '¿Puedo usar Qwen Image para proyectos comerciales?',
        faq5Answer: 'Sí. Las capacidades de generación de imágenes de alta precisión y expresión creativa de Qwen Image lo convierten en una opción poderosa para diseñadores, artistas y creadores de contenido que buscan imágenes generadas por IA de alta calidad.',
    
        // CTA Section
        ctaTitle: '¿Listo para Comenzar a Crear?',
        ctaDescription: 'Experimenta Qwen Image ahora y transforma tus ideas en imágenes increíbles',
        ctaButton: 'Prueba Qwen Image en 微鲤AI',
        ctaDisclaimer: 'No se requiere tarjeta de crédito',
    },
    fr: {
        // SEO Meta
        pageTitle: 'Générateur d\'Images IA Qwen Image - Texte vers Image Gratuit',
        pageDescription: 'Qwen Image par Alibaba est un modèle IA open-source fondamental qui excelle dans la génération et l\'édition d\'images stylisées avec une intégration de texte complexe exceptionnelle. Essayez Qwen Image gratuitement sur le générateur d\'images 微鲤AI !',
        pageKeywords: 'Qwen Image, Alibaba, génération d\'images IA, art IA, intelligence artificielle, édition d\'images, expression créative',
    
        // Open Graph
        ogTitle: 'Générateur d\'Images IA Qwen Image - Texte vers Image Gratuit',
        ogDescription: 'Qwen Image par Alibaba est un modèle IA open-source fondamental qui excelle dans la génération et l\'édition d\'images stylisées avec une intégration de texte complexe exceptionnelle.',
    
        // Twitter Card
        twitterTitle: 'Générateur d\'Images IA Qwen Image - Texte vers Image Gratuit',
        twitterDescription: 'Qwen Image par Alibaba excelle dans la génération et l\'édition d\'images stylisées avec une intégration de texte complexe exceptionnelle.',
    
        // Generator Section
        generatorTitle: 'Générateur d\'Images IA Qwen Image',
        generatorSubtitle: 'Qwen Image par Alibaba est un modèle IA open-source fondamental qui excelle dans la génération et l\'édition d\'images stylisées avec une intégration de texte complexe exceptionnelle. Essayez Qwen Image gratuitement sur le générateur d\'images 微鲤AI !',
    
        // Core Features Section
        coreFeaturesTitle: 'Fonctionnalités Principales de Qwen Image',
        coreFeaturesSubtitle: 'Explorez les fonctionnalités principales du générateur d\'images IA Qwen Image et lancez-vous dans un voyage révolutionnaire de création d\'images IA',
    
        // Features
        diverseImageTitle: 'Génération d\'Images Diverses',
        diverseImageDesc: 'Créez des images vives dans différents styles. Qwen Image génère des images de qualité professionnelle supportant plusieurs styles artistiques et expression créative, étendant votre créativité infiniment.',
        diverseImageAlt: 'Exemple de Génération d\'Images Diverses',
    
        intuitiveEditingTitle: 'Édition d\'Images Intuitive',
        intuitiveEditingDesc: 'Supporte l\'édition de niveau professionnel en utilisant le langage quotidien. Grâce à de simples descriptions textuelles, vous pouvez ajuster avec précision les détails, couleurs, styles et composition des images sans opérations complexes.',
        intuitiveEditingAlt: 'Exemple d\'Édition d\'Images Intuitive',
    
        fineTextRenderingTitle: 'Rendu de Texte à Grain Fin',
        fineTextRenderingDesc: 'Intégrez en toute transparence du texte multilingue dans les images. Supporte le rendu de texte dans diverses langues, assurant une fusion parfaite du texte et des images pour créer des effets visuels professionnels.',
        fineTextRenderingAlt: 'Exemple de Rendu de Texte à Grain Fin',
    
        smartPromptTitle: 'Suivi Intelligent des Prompts',
        smartPromptDesc: 'Possède une compréhension visuelle approfondie pour réaliser des instructions créatives. Analyse intelligemment vos besoins, comprend précisément l\'intention créative et génère des images de haute qualité qui répondent aux attentes.',
        smartPromptAlt: 'Exemple de Suivi Intelligent des Prompts',
    
        // How to Use Section
        howToUseTitle: 'Comment Utiliser',
        howToUseSubtitle: 'Trois étapes simples pour commencer à créer',
    
        step1Title: 'Sélectionner le Modèle',
        step1Description: 'Choisissez le modèle Qwen Image dans les outils d\'image IA',
    
        step2Title: 'Entrer le Contenu',
        step2Description: 'Saisissez des prompts ou téléchargez des images de référence',
    
        step3Title: 'Générer l\'Image',
        step3Description: 'Cliquez sur le bouton générer, attendez et téléchargez votre image',
    
        // YouTube Videos Section
        youtubeTitle: 'Vidéos YouTube sur le Modèle IA Qwen Image',
    
        // X Posts Section
        xPostsTitle: 'Publications X sur le Modèle IA Qwen Image',
    
        // Explore Other Models Section
        exploreModelsTitle: 'Explorez d\'Autres Modèles d\'Image IA sur 微鲤AI',
        model1Title: 'Générateur d\'Images IA Google Nano Banana',
        model2Title: 'Générateur d\'Images IA FLUX',
        model3Title: 'Générateur d\'Images IA Google Imagen',
    
        // FAQ Section
        faqTitle: 'Questions Fréquemment Posées',
    
        faq1Question: 'Qu\'est-ce que Qwen Image ?',
        faq1Answer: 'Qwen Image est un modèle de génération d\'images IA open-source développé par Alibaba, avec une qualité d\'image exceptionnelle et des capacités d\'expression créative pouvant générer des images de qualité professionnelle.',
    
        faq2Question: 'Quels avantages Qwen Image a-t-il par rapport aux autres modèles de génération d\'images ?',
        faq2Answer: 'Qwen Image présente des avantages significatifs en matière de qualité d\'image, d\'expression créative, de contrôle du style et de rendu de texte. Il peut générer des images de qualité professionnelle et supporte l\'intégration de texte complexe.',
    
        faq3Question: 'Puis-je utiliser Qwen Image gratuitement ?',
        faq3Answer: 'Oui. Qwen Image offre des crédits gratuits limités via l\'essai gratuit de 微鲤AI. Pour une utilisation extensive, une mise à niveau est nécessaire.',
    
        faq4Question: 'Quels formats d\'image Qwen Image supporte-t-il ?',
        faq4Answer: 'Qwen Image supporte divers formats d\'image dont JPG, PNG, WEBP et autres formats courants. Les images générées présentent une haute qualité et des détails riches.',
    
        faq5Question: 'Puis-je utiliser Qwen Image pour des projets commerciaux ?',
        faq5Answer: 'Oui. Les capacités de génération d\'images haute précision et d\'expression créative de Qwen Image en font un choix puissant pour les designers, artistes et créateurs de contenu recherchant des images générées par IA de haute qualité.',
    
        // CTA Section
        ctaTitle: 'Prêt à Commencer à Créer ?',
        ctaDescription: 'Découvrez Qwen Image maintenant et transformez vos idées en images incroyables',
        ctaButton: 'Essayez Qwen Image sur 微鲤AI',
        ctaDisclaimer: 'Aucune carte de crédit requise',
    },
    de: {
        // SEO Meta
        pageTitle: 'Qwen Image KI-Bildgenerator - Kostenlos Text zu Bild',
        pageDescription: 'Qwen Image von Alibaba ist ein grundlegendes Open-Source-KI-Modell, das sich durch die Generierung und Bearbeitung stilisierter Bilder mit herausragender komplexer Textintegration auszeichnet. Testen Sie Qwen Image kostenlos auf dem 微鲤AI Bildgenerator!',
        pageKeywords: 'Qwen Image, Alibaba, KI-Bildgenerierung, KI-Kunst, künstliche Intelligenz, Bildbearbeitung, kreativer Ausdruck',
    
        // Open Graph
        ogTitle: 'Qwen Image KI-Bildgenerator - Kostenlos Text zu Bild',
        ogDescription: 'Qwen Image von Alibaba ist ein grundlegendes Open-Source-KI-Modell, das sich durch die Generierung und Bearbeitung stilisierter Bilder mit herausragender komplexer Textintegration auszeichnet.',
    
        // Twitter Card
        twitterTitle: 'Qwen Image KI-Bildgenerator - Kostenlos Text zu Bild',
        twitterDescription: 'Qwen Image von Alibaba zeichnet sich durch die Generierung und Bearbeitung stilisierter Bilder mit herausragender komplexer Textintegration aus.',
    
        // Generator Section
        generatorTitle: 'Qwen Image KI-Bildgenerator',
        generatorSubtitle: 'Qwen Image von Alibaba ist ein grundlegendes Open-Source-KI-Modell, das sich durch die Generierung und Bearbeitung stilisierter Bilder mit herausragender komplexer Textintegration auszeichnet. Testen Sie Qwen Image kostenlos auf dem 微鲤AI Bildgenerator!',
    
        // Core Features Section
        coreFeaturesTitle: 'Qwen Image Kernfunktionen',
        coreFeaturesSubtitle: 'Erkunden Sie die Kernfunktionen des Qwen Image KI-Bildgenerators und begeben Sie sich auf eine revolutionäre KI-Bilderstellungsreise',
    
        // Features
        diverseImageTitle: 'Vielfältige Bildgenerierung',
        diverseImageDesc: 'Erstellen Sie lebendige Bilder in verschiedenen Stilen. Qwen Image generiert professionelle Bilder, die mehrere künstlerische Stile und kreativen Ausdruck unterstützen und Ihre Kreativität unendlich erweitern.',
        diverseImageAlt: 'Beispiel für Vielfältige Bildgenerierung',
    
        intuitiveEditingTitle: 'Intuitive Bildbearbeitung',
        intuitiveEditingDesc: 'Unterstützt professionelle Bearbeitung in Alltagssprache. Durch einfache Textbeschreibungen können Sie Bilddetails, Farben, Stile und Komposition ohne komplexe Operationen präzise anpassen.',
        intuitiveEditingAlt: 'Beispiel für Intuitive Bildbearbeitung',
    
        fineTextRenderingTitle: 'Feingranulares Text-Rendering',
        fineTextRenderingDesc: 'Integrieren Sie nahtlos mehrsprachigen Text in Bilder. Unterstützt Text-Rendering in verschiedenen Sprachen und sorgt für eine perfekte Verschmelzung von Text und Bildern zur Erstellung professioneller visueller Effekte.',
        fineTextRenderingAlt: 'Beispiel für Feingranulares Text-Rendering',
    
        smartPromptTitle: 'Intelligente Prompt-Befolgung',
        smartPromptDesc: 'Besitzt tiefes visuelles Verständnis zur Umsetzung kreativer Anweisungen. Analysiert intelligent Ihre Bedürfnisse, versteht präzise kreative Absichten und generiert hochwertige Bilder, die Erwartungen erfüllen.',
        smartPromptAlt: 'Beispiel für Intelligente Prompt-Befolgung',
    
        // How to Use Section
        howToUseTitle: 'Wie Man Verwendet',
        howToUseSubtitle: 'Drei einfache Schritte zum Erstellen',
    
        step1Title: 'Modell Auswählen',
        step1Description: 'Wählen Sie das Qwen Image Modell in den KI-Bildwerkzeugen',
    
        step2Title: 'Inhalt Eingeben',
        step2Description: 'Geben Sie Prompts ein oder laden Sie Referenzbilder hoch',
    
        step3Title: 'Bild Generieren',
        step3Description: 'Klicken Sie auf die Generieren-Schaltfläche, warten Sie und laden Sie Ihr Bild herunter',
    
        // YouTube Videos Section
        youtubeTitle: 'YouTube-Videos über das Qwen Image KI-Modell',
    
        // X Posts Section
        xPostsTitle: 'X-Beiträge über das Qwen Image KI-Modell',
    
        // Explore Other Models Section
        exploreModelsTitle: 'Erkunden Sie Andere KI-Bildmodelle auf 微鲤AI',
        model1Title: 'Google Nano Banana KI-Bildgenerator',
        model2Title: 'FLUX KI-Bildgenerator',
        model3Title: 'Google Imagen KI-Bildgenerator',
    
        // FAQ Section
        faqTitle: 'Häufig Gestellte Fragen',
    
        faq1Question: 'Was ist Qwen Image?',
        faq1Answer: 'Qwen Image ist ein Open-Source-KI-Bildgenerierungsmodell, das von Alibaba entwickelt wurde und außergewöhnliche Bildqualität sowie kreative Ausdrucksfähigkeiten aufweist, die professionelle Bilder generieren können.',
    
        faq2Question: 'Welche Vorteile hat Qwen Image gegenüber anderen Bildgenerierungsmodellen?',
        faq2Answer: 'Qwen Image hat erhebliche Vorteile in Bildqualität, kreativem Ausdruck, Stilkontrolle und Text-Rendering. Es kann hochwertige professionelle Bilder generieren und unterstützt komplexe Textintegration.',
    
        faq3Question: 'Kann ich Qwen Image kostenlos verwenden?',
        faq3Answer: 'Ja. Qwen Image bietet begrenzte kostenlose Credits über die kostenlose Testversion von 微鲤AI. Für umfangreiche Nutzung ist ein Upgrade erforderlich.',
    
        faq4Question: 'Welche Bildformate unterstützt Qwen Image?',
        faq4Answer: 'Qwen Image unterstützt verschiedene Bildformate einschließlich JPG, PNG, WEBP und andere gängige Formate. Generierte Bilder zeichnen sich durch hohe Qualität und reiche Details aus.',
    
        faq5Question: 'Kann ich Qwen Image für kommerzielle Projekte verwenden?',
        faq5Answer: 'Ja. Qwen Images hochpräzise Bildgenerierung und kreative Ausdrucksfähigkeiten machen es zu einer leistungsstarken Wahl für Designer, Künstler und Content-Ersteller, die hochwertige KI-generierte Bilder suchen.',
    
        // CTA Section
        ctaTitle: 'Bereit zum Erstellen?',
        ctaDescription: 'Erleben Sie Qwen Image jetzt und verwandeln Sie Ihre Ideen in erstaunliche Bilder',
        ctaButton: 'Testen Sie Qwen Image auf 微鲤AI',
        ctaDisclaimer: 'Keine Kreditkarte erforderlich',
    },
    ru: {
        // SEO Meta
        pageTitle: 'Генератор изображений Qwen Image AI - Бесплатно от текста к изображению',
        pageDescription: 'Qwen Image от Alibaba - это фундаментальная модель ИИ с открытым исходным кодом, которая превосходно справляется с генерацией и редактированием стилизованных изображений с выдающейся интеграцией сложного текста. Попробуйте Qwen Image бесплатно на генераторе изображений 微鲤AI!',
        pageKeywords: 'Qwen Image, Alibaba, генерация изображений AI, AI-арт, искусственный интеллект, редактирование изображений, творческое выражение',
    
        // Open Graph
        ogTitle: 'Генератор изображений Qwen Image AI - Бесплатно от текста к изображению',
        ogDescription: 'Qwen Image от Alibaba - это фундаментальная модель ИИ с открытым исходным кодом, которая превосходно справляется с генерацией и редактированием стилизованных изображений с выдающейся интеграцией сложного текста.',
    
        // Twitter Card
        twitterTitle: 'Генератор изображений Qwen Image AI - Бесплатно от текста к изображению',
        twitterDescription: 'Qwen Image от Alibaba превосходно справляется с генерацией и редактированием стилизованных изображений с выдающейся интеграцией сложного текста.',
    
        // Generator Section
        generatorTitle: 'Генератор изображений Qwen Image AI',
        generatorSubtitle: 'Qwen Image от Alibaba - это фундаментальная модель ИИ с открытым исходным кодом, которая превосходно справляется с генерацией и редактированием стилизованных изображений с выдающейся интеграцией сложного текста. Попробуйте Qwen Image бесплатно на генераторе изображений 微鲤AI!',
    
        // Core Features Section
        coreFeaturesTitle: 'Основные функции Qwen Image',
        coreFeaturesSubtitle: 'Изучите основные функции генератора изображений Qwen Image AI и отправьтесь в революционное путешествие по созданию изображений AI',
    
        // Features
        diverseImageTitle: 'Разнообразная генерация изображений',
        diverseImageDesc: 'Создавайте яркие изображения в различных стилях. Qwen Image генерирует изображения профессионального качества, поддерживающие множество художественных стилей и творческого выражения, бесконечно расширяя вашу креативность.',
        diverseImageAlt: 'Пример разнообразной генерации изображений',
    
        intuitiveEditingTitle: 'Интуитивное редактирование изображений',
        intuitiveEditingDesc: 'Поддерживает редактирование профессионального уровня на повседневном языке. С помощью простых текстовых описаний вы можете точно настраивать детали, цвета, стили и композицию изображений без сложных операций.',
        intuitiveEditingAlt: 'Пример интуитивного редактирования изображений',
    
        fineTextRenderingTitle: 'Детальная отрисовка текста',
        fineTextRenderingDesc: 'Безупречно интегрируйте многоязычный текст в изображения. Поддерживает отрисовку текста на различных языках, обеспечивая идеальное слияние текста и изображений для создания профессиональных визуальных эффектов.',
        fineTextRenderingAlt: 'Пример детальной отрисовки текста',
    
        smartPromptTitle: 'Умное следование промптам',
        smartPromptDesc: 'Обладает глубоким визуальным пониманием для реализации творческих инструкций. Интеллектуально анализирует ваши потребности, точно понимает творческие намерения и генерирует высококачественные изображения, соответствующие ожиданиям.',
        smartPromptAlt: 'Пример умного следования промптам',
    
        // How to Use Section
        howToUseTitle: 'Как использовать',
        howToUseSubtitle: 'Три простых шага для начала создания',
    
        step1Title: 'Выберите модель',
        step1Description: 'Выберите модель Qwen Image в инструментах AI-изображений',
    
        step2Title: 'Введите содержимое',
        step2Description: 'Введите промпты или загрузите референсные изображения',
    
        step3Title: 'Сгенерируйте изображение',
        step3Description: 'Нажмите кнопку генерации, дождитесь и скачайте изображение',
    
        // YouTube Videos Section
        youtubeTitle: 'Видео на YouTube о модели AI Qwen Image',
    
        // X Posts Section
        xPostsTitle: 'Посты в X о модели AI Qwen Image',
    
        // Explore Other Models Section
        exploreModelsTitle: 'Исследуйте другие модели AI-изображений на 微鲤AI',
        model1Title: 'Генератор изображений Google Nano Banana AI',
        model2Title: 'Генератор изображений FLUX AI',
        model3Title: 'Генератор изображений Google Imagen AI',
    
        // FAQ Section
        faqTitle: 'Часто задаваемые вопросы',
    
        faq1Question: 'Что такое Qwen Image?',
        faq1Answer: 'Qwen Image - это модель генерации изображений AI с открытым исходным кодом, разработанная Alibaba, с исключительным качеством изображений и возможностями творческого выражения, способная создавать изображения профессионального уровня.',
    
        faq2Question: 'Какие преимущества имеет Qwen Image перед другими моделями генерации изображений?',
        faq2Answer: 'Qwen Image имеет значительные преимущества в качестве изображений, творческом выражении, контроле стиля и отрисовке текста. Он может создавать высококачественные изображения профессионального уровня и поддерживает сложную интеграцию текста.',
    
        faq3Question: 'Могу ли я использовать Qwen Image бесплатно?',
        faq3Answer: 'Да. Qwen Image предлагает ограниченные бесплатные кредиты через бесплатную пробную версию 微鲤AI. Для обширного использования требуется обновление.',
    
        faq4Question: 'Какие форматы изображений поддерживает Qwen Image?',
        faq4Answer: 'Qwen Image поддерживает различные форматы изображений, включая JPG, PNG, WEBP и другие распространенные форматы. Созданные изображения отличаются высоким качеством и богатыми деталями.',
    
        faq5Question: 'Могу ли я использовать Qwen Image для коммерческих проектов?',
        faq5Answer: 'Да. Высокоточная генерация изображений и возможности творческого выражения Qwen Image делают его мощным выбором для дизайнеров, художников и создателей контента, ищущих высококачественные AI-изображения.',
    
        // CTA Section
        ctaTitle: 'Готовы начать создавать?',
        ctaDescription: 'Испытайте Qwen Image сейчас и превратите свои идеи в потрясающие изображения',
        ctaButton: 'Попробуйте Qwen Image на 微鲤AI',
        ctaDisclaimer: 'Кредитная карта не требуется',
    },
    pt: {
        // SEO Meta
        pageTitle: 'Gerador de Imagens IA Qwen Image - Texto para Imagem Grátis',
        pageDescription: 'Qwen Image da Alibaba é um modelo IA de código aberto fundamental que se destaca em gerar e editar imagens estilizadas com integração de texto complexo excepcional. Experimente Qwen Image gratuitamente no gerador de imagens 微鲤AI!',
        pageKeywords: 'Qwen Image, Alibaba, geração de imagens IA, arte IA, inteligência artificial, edição de imagens, expressão criativa',
    
        // Open Graph
        ogTitle: 'Gerador de Imagens IA Qwen Image - Texto para Imagem Grátis',
        ogDescription: 'Qwen Image da Alibaba é um modelo IA de código aberto fundamental que se destaca em gerar e editar imagens estilizadas com integração de texto complexo excepcional.',
    
        // Twitter Card
        twitterTitle: 'Gerador de Imagens IA Qwen Image - Texto para Imagem Grátis',
        twitterDescription: 'Qwen Image da Alibaba se destaca em gerar e editar imagens estilizadas com integração de texto complexo excepcional.',
    
        // Generator Section
        generatorTitle: 'Gerador de Imagens IA Qwen Image',
        generatorSubtitle: 'Qwen Image da Alibaba é um modelo IA de código aberto fundamental que se destaca em gerar e editar imagens estilizadas com integração de texto complexo excepcional. Experimente Qwen Image gratuitamente no gerador de imagens 微鲤AI!',
    
        // Core Features Section
        coreFeaturesTitle: 'Recursos Principais do Qwen Image',
        coreFeaturesSubtitle: 'Explore os recursos principais do gerador de imagens IA Qwen Image e embarque em uma jornada revolucionária de criação de imagens IA',
    
        // Features
        diverseImageTitle: 'Geração de Imagens Diversas',
        diverseImageDesc: 'Crie imagens vívidas em vários estilos. Qwen Image gera imagens de qualidade profissional que suportam múltiplos estilos artísticos e expressão criativa, estendendo sua criatividade infinitamente.',
        diverseImageAlt: 'Exemplo de Geração de Imagens Diversas',
    
        intuitiveEditingTitle: 'Edição de Imagens Intuitiva',
        intuitiveEditingDesc: 'Suporta edição de nível profissional usando linguagem cotidiana. Através de descrições de texto simples, você pode ajustar com precisão detalhes, cores, estilos e composição de imagens sem operações complexas.',
        intuitiveEditingAlt: 'Exemplo de Edição de Imagens Intuitiva',
    
        fineTextRenderingTitle: 'Renderização de Texto de Grão Fino',
        fineTextRenderingDesc: 'Integre perfeitamente texto multilíngue em imagens. Suporta renderização de texto em vários idiomas, garantindo fusão perfeita de texto e imagens para criar efeitos visuais profissionais.',
        fineTextRenderingAlt: 'Exemplo de Renderização de Texto de Grão Fino',
    
        smartPromptTitle: 'Seguimento Inteligente de Prompts',
        smartPromptDesc: 'Possui compreensão visual profunda para realizar instruções criativas. Analisa inteligentemente suas necessidades, compreende precisamente a intenção criativa e gera imagens de alta qualidade que atendem às expectativas.',
        smartPromptAlt: 'Exemplo de Seguimento Inteligente de Prompts',
    
        // How to Use Section
        howToUseTitle: 'Como Usar',
        howToUseSubtitle: 'Três passos simples para começar a criar',
    
        step1Title: 'Selecionar Modelo',
        step1Description: 'Escolha o modelo Qwen Image nas ferramentas de imagem IA',
    
        step2Title: 'Inserir Conteúdo',
        step2Description: 'Digite prompts ou carregue imagens de referência',
    
        step3Title: 'Gerar Imagem',
        step3Description: 'Clique no botão gerar, aguarde e baixe sua imagem',
    
        // YouTube Videos Section
        youtubeTitle: 'Vídeos do YouTube sobre o Modelo IA Qwen Image',
    
        // X Posts Section
        xPostsTitle: 'Posts do X sobre o Modelo IA Qwen Image',
    
        // Explore Other Models Section
        exploreModelsTitle: 'Explore Outros Modelos de Imagem IA no 微鲤AI',
        model1Title: 'Gerador de Imagens IA Google Nano Banana',
        model2Title: 'Gerador de Imagens IA FLUX',
        model3Title: 'Gerador de Imagens IA Google Imagen',
    
        // FAQ Section
        faqTitle: 'Perguntas Frequentes',
    
        faq1Question: 'O que é Qwen Image?',
        faq1Answer: 'Qwen Image é um modelo de geração de imagens IA de código aberto desenvolvido pela Alibaba, com qualidade de imagem excepcional e capacidades de expressão criativa que podem gerar imagens de nível profissional.',
    
        faq2Question: 'Quais vantagens o Qwen Image tem sobre outros modelos de geração de imagens?',
        faq2Answer: 'Qwen Image tem vantagens significativas em qualidade de imagem, expressão criativa, controle de estilo e renderização de texto. Ele pode gerar imagens de nível profissional de alta qualidade e suporta integração de texto complexo.',
    
        faq3Question: 'Posso usar o Qwen Image gratuitamente?',
        faq3Answer: 'Sim. O Qwen Image oferece créditos gratuitos limitados através do teste gratuito do 微鲤AI. Para uso extensivo, é necessária uma atualização.',
    
        faq4Question: 'Quais formatos de imagem o Qwen Image suporta?',
        faq4Answer: 'O Qwen Image suporta vários formatos de imagem, incluindo JPG, PNG, WEBP e outros formatos comuns. As imagens geradas apresentam alta qualidade e detalhes ricos.',
    
        faq5Question: 'Posso usar o Qwen Image para projetos comerciais?',
        faq5Answer: 'Sim. As capacidades de geração de imagens de alta precisão e expressão criativa do Qwen Image o tornam uma escolha poderosa para designers, artistas e criadores de conteúdo que buscam imagens geradas por IA de alta qualidade.',
    
        // CTA Section
        ctaTitle: 'Pronto para Começar a Criar?',
        ctaDescription: 'Experimente o Qwen Image agora e transforme suas ideias em imagens incríveis',
        ctaButton: 'Experimente o Qwen Image no 微鲤AI',
        ctaDisclaimer: 'Não é necessário cartão de crédito',
    },
    it: {
        // SEO Meta
        pageTitle: 'Generatore di Immagini IA Qwen Image - Testo a Immagine Gratuito',
        pageDescription: 'Qwen Image di Alibaba è un modello IA open-source fondamentale che eccelle nel generare e modificare immagini stilizzate con un\'integrazione di testo complesso eccezionale. Prova Qwen Image gratuitamente sul generatore di immagini 微鲤AI!',
        pageKeywords: 'Qwen Image, Alibaba, generazione di immagini IA, arte IA, intelligenza artificiale, modifica di immagini, espressione creativa',
    
        // Open Graph
        ogTitle: 'Generatore di Immagini IA Qwen Image - Testo a Immagine Gratuito',
        ogDescription: 'Qwen Image di Alibaba è un modello IA open-source fondamentale che eccelle nel generare e modificare immagini stilizzate con un\'integrazione di testo complesso eccezionale.',
    
        // Twitter Card
        twitterTitle: 'Generatore di Immagini IA Qwen Image - Testo a Immagine Gratuito',
        twitterDescription: 'Qwen Image di Alibaba eccelle nel generare e modificare immagini stilizzate con un\'integrazione di testo complesso eccezionale.',
    
        // Generator Section
        generatorTitle: 'Generatore di Immagini IA Qwen Image',
        generatorSubtitle: 'Qwen Image di Alibaba è un modello IA open-source fondamentale che eccelle nel generare e modificare immagini stilizzate con un\'integrazione di testo complesso eccezionale. Prova Qwen Image gratuitamente sul generatore di immagini 微鲤AI!',
    
        // Core Features Section
        coreFeaturesTitle: 'Caratteristiche Principali di Qwen Image',
        coreFeaturesSubtitle: 'Esplora le caratteristiche principali del generatore di immagini IA Qwen Image e intraprendi un viaggio rivoluzionario nella creazione di immagini IA',
    
        // Features
        diverseImageTitle: 'Generazione di Immagini Diverse',
        diverseImageDesc: 'Crea immagini vivide in vari stili. Qwen Image genera immagini di qualità professionale che supportano molteplici stili artistici ed espressione creativa, estendendo la tua creatività infinitamente.',
        diverseImageAlt: 'Esempio di Generazione di Immagini Diverse',
    
        intuitiveEditingTitle: 'Modifica di Immagini Intuitiva',
        intuitiveEditingDesc: 'Supporta la modifica di livello professionale usando il linguaggio quotidiano. Attraverso semplici descrizioni testuali, puoi regolare con precisione dettagli, colori, stili e composizione delle immagini senza operazioni complesse.',
        intuitiveEditingAlt: 'Esempio di Modifica di Immagini Intuitiva',
    
        fineTextRenderingTitle: 'Rendering di Testo a Grana Fine',
        fineTextRenderingDesc: 'Integra perfettamente testo multilingue nelle immagini. Supporta il rendering di testo in varie lingue, assicurando una fusione perfetta di testo e immagini per creare effetti visivi professionali.',
        fineTextRenderingAlt: 'Esempio di Rendering di Testo a Grana Fine',
    
        smartPromptTitle: 'Seguimento Intelligente dei Prompt',
        smartPromptDesc: 'Possiede una comprensione visiva profonda per realizzare istruzioni creative. Analizza intelligentemente le tue esigenze, comprende precisamente l\'intenzione creativa e genera immagini di alta qualità che soddisfano le aspettative.',
        smartPromptAlt: 'Esempio di Seguimento Intelligente dei Prompt',
    
        // How to Use Section
        howToUseTitle: 'Come Usare',
        howToUseSubtitle: 'Tre semplici passaggi per iniziare a creare',
    
        step1Title: 'Seleziona Modello',
        step1Description: 'Scegli il modello Qwen Image negli strumenti di immagini IA',
    
        step2Title: 'Inserisci Contenuto',
        step2Description: 'Inserisci prompt o carica immagini di riferimento',
    
        step3Title: 'Genera Immagine',
        step3Description: 'Clicca sul pulsante genera, attendi e scarica la tua immagine',
    
        // YouTube Videos Section
        youtubeTitle: 'Video di YouTube sul Modello IA Qwen Image',
    
        // X Posts Section
        xPostsTitle: 'Post di X sul Modello IA Qwen Image',
    
        // Explore Other Models Section
        exploreModelsTitle: 'Esplora Altri Modelli di Immagine IA su 微鲤AI',
        model1Title: 'Generatore di Immagini IA Google Nano Banana',
        model2Title: 'Generatore di Immagini IA FLUX',
        model3Title: 'Generatore di Immagini IA Google Imagen',
    
        // FAQ Section
        faqTitle: 'Domande Frequenti',
    
        faq1Question: 'Cos\'è Qwen Image?',
        faq1Answer: 'Qwen Image è un modello di generazione di immagini IA open-source sviluppato da Alibaba, con qualità dell\'immagine eccezionale e capacità di espressione creativa in grado di generare immagini di livello professionale.',
    
        faq2Question: 'Quali vantaggi ha Qwen Image rispetto ad altri modelli di generazione di immagini?',
        faq2Answer: 'Qwen Image ha vantaggi significativi in qualità dell\'immagine, espressione creativa, controllo dello stile e rendering del testo. Può generare immagini di livello professionale di alta qualità e supporta l\'integrazione di testo complesso.',
    
        faq3Question: 'Posso usare Qwen Image gratuitamente?',
        faq3Answer: 'Sì. Qwen Image offre crediti gratuiti limitati attraverso la prova gratuita di 微鲤AI. Per un uso estensivo, è necessario un upgrade.',
    
        faq4Question: 'Quali formati di immagine supporta Qwen Image?',
        faq4Answer: 'Qwen Image supporta vari formati di immagine tra cui JPG, PNG, WEBP e altri formati comuni. Le immagini generate presentano alta qualità e dettagli ricchi.',
    
        faq5Question: 'Posso usare Qwen Image per progetti commerciali?',
        faq5Answer: 'Sì. Le capacità di generazione di immagini ad alta precisione e di espressione creativa di Qwen Image lo rendono una scelta potente per designer, artisti e creatori di contenuti che cercano immagini generate da IA di alta qualità.',
    
        // CTA Section
        ctaTitle: 'Pronto per Iniziare a Creare?',
        ctaDescription: 'Prova Qwen Image ora e trasforma le tue idee in immagini straordinarie',
        ctaButton: 'Prova Qwen Image su 微鲤AI',
        ctaDisclaimer: 'Non è richiesta la carta di credito',
    },
    ar: {
        // SEO Meta
        pageTitle: 'مولد الصور بالذكاء الاصطناعي Qwen Image - نص إلى صورة مجاني',
        pageDescription: 'Qwen Image من Alibaba هو نموذج ذكاء اصطناعي مفتوح المصدر أساسي يتفوق في إنشاء وتحرير الصور المنمقة بتكامل نصي معقد استثنائي. جرب Qwen Image مجانًا على مولد الصور 微鲤AI!',
        pageKeywords: 'Qwen Image, Alibaba, إنشاء صور الذكاء الاصطناعي, فن الذكاء الاصطناعي, الذكاء الاصطناعي, تحرير الصور, التعبير الإبداعي',
    
        // Open Graph
        ogTitle: 'مولد الصور بالذكاء الاصطناعي Qwen Image - نص إلى صورة مجاني',
        ogDescription: 'Qwen Image من Alibaba هو نموذج ذكاء اصطناعي مفتوح المصدر أساسي يتفوق في إنشاء وتحرير الصور المنمقة بتكامل نصي معقد استثنائي.',
    
        // Twitter Card
        twitterTitle: 'مولد الصور بالذكاء الاصطناعي Qwen Image - نص إلى صورة مجاني',
        twitterDescription: 'Qwen Image من Alibaba يتفوق في إنشاء وتحرير الصور المنمقة بتكامل نصي معقد استثنائي.',
    
        // Generator Section
        generatorTitle: 'مولد الصور بالذكاء الاصطناعي Qwen Image',
        generatorSubtitle: 'Qwen Image من Alibaba هو نموذج ذكاء اصطناعي مفتوح المصدر أساسي يتفوق في إنشاء وتحرير الصور المنمقة بتكامل نصي معقد استثنائي. جرب Qwen Image مجانًا على مولد الصور 微鲤AI!',
    
        // Core Features Section
        coreFeaturesTitle: 'الميزات الأساسية لـ Qwen Image',
        coreFeaturesSubtitle: 'استكشف الميزات الأساسية لمولد الصور بالذكاء الاصطناعي Qwen Image وابدأ رحلة ثورية لإنشاء صور بالذكاء الاصطناعي',
    
        // Features
        diverseImageTitle: 'إنشاء صور متنوعة',
        diverseImageDesc: 'قم بإنشاء صور حية بأنماط مختلفة. يُنشئ Qwen Image صورًا بجودة احترافية تدعم أنماط فنية متعددة والتعبير الإبداعي، مما يوسع إبداعك بلا حدود.',
        diverseImageAlt: 'مثال على إنشاء صور متنوعة',
    
        intuitiveEditingTitle: 'تحرير صور بديهي',
        intuitiveEditingDesc: 'يدعم التحرير على المستوى الاحترافي باستخدام اللغة اليومية. من خلال أوصاف نصية بسيطة، يمكنك ضبط تفاصيل الصورة والألوان والأنماط والتكوين بدقة دون عمليات معقدة.',
        intuitiveEditingAlt: 'مثال على تحرير صور بديهي',
    
        fineTextRenderingTitle: 'عرض نص دقيق الحبيبات',
        fineTextRenderingDesc: 'دمج النص متعدد اللغات بسلاسة في الصور. يدعم عرض النص بلغات مختلفة، مما يضمن الدمج المثالي للنص والصور لإنشاء تأثيرات بصرية احترافية.',
        fineTextRenderingAlt: 'مثال على عرض نص دقيق الحبيبات',
    
        smartPromptTitle: 'متابعة ذكية للمطالبات',
        smartPromptDesc: 'يمتلك فهمًا بصريًا عميقًا لتحقيق التعليمات الإبداعية. يحلل احتياجاتك بذكاء، ويفهم النية الإبداعية بدقة، ويولد صورًا عالية الجودة تلبي التوقعات.',
        smartPromptAlt: 'مثال على متابعة ذكية للمطالبات',
    
        // How to Use Section
        howToUseTitle: 'كيفية الاستخدام',
        howToUseSubtitle: 'ثلاث خطوات بسيطة لبدء الإنشاء',
    
        step1Title: 'اختر النموذج',
        step1Description: 'اختر نموذج Qwen Image في أدوات الصور بالذكاء الاصطناعي',
    
        step2Title: 'أدخل المحتوى',
        step2Description: 'أدخل المطالبات أو قم بتحميل صور مرجعية',
    
        step3Title: 'أنشئ الصورة',
        step3Description: 'انقر فوق زر الإنشاء، انتظر وقم بتنزيل صورتك',
    
        // YouTube Videos Section
        youtubeTitle: 'فيديوهات YouTube حول نموذج الذكاء الاصطناعي Qwen Image',
    
        // X Posts Section
        xPostsTitle: 'منشورات X حول نموذج الذكاء الاصطناعي Qwen Image',
    
        // Explore Other Models Section
        exploreModelsTitle: 'استكشف نماذج الصور بالذكاء الاصطناعي الأخرى على 微鲤AI',
        model1Title: 'مولد الصور بالذكاء الاصطناعي Google Nano Banana',
        model2Title: 'مولد الصور بالذكاء الاصطناعي FLUX',
        model3Title: 'مولد الصور بالذكاء الاصطناعي Google Imagen',
    
        // FAQ Section
        faqTitle: 'الأسئلة الشائعة',
    
        faq1Question: 'ما هو Qwen Image؟',
        faq1Answer: 'Qwen Image هو نموذج إنشاء صور بالذكاء الاصطناعي مفتوح المصدر تم تطويره بواسطة Alibaba، يتميز بجودة صورة استثنائية وقدرات تعبير إبداعي يمكنها إنشاء صور بمستوى احترافي.',
    
        faq2Question: 'ما المزايا التي يتمتع بها Qwen Image مقارنة بنماذج إنشاء الصور الأخرى؟',
        faq2Answer: 'يتمتع Qwen Image بمزايا كبيرة في جودة الصورة والتعبير الإبداعي والتحكم في الأسلوب وعرض النص. يمكنه إنشاء صور بمستوى احترافي عالية الجودة ويدعم تكامل النص المعقد.',
    
        faq3Question: 'هل يمكنني استخدام Qwen Image مجانًا؟',
        faq3Answer: 'نعم. يقدم Qwen Image أرصدة مجانية محدودة من خلال الإصدار التجريبي المجاني من 微鲤AI. للاستخدام المكثف، يلزم الترقية.',
    
        faq4Question: 'ما تنسيقات الصور التي يدعمها Qwen Image؟',
        faq4Answer: 'يدعم Qwen Image تنسيقات صور مختلفة بما في ذلك JPG و PNG و WEBP وتنسيقات شائعة أخرى. تتميز الصور المُنشأة بجودة عالية وتفاصيل غنية.',
    
        faq5Question: 'هل يمكنني استخدام Qwen Image للمشاريع التجارية؟',
        faq5Answer: 'نعم. تجعل قدرات إنشاء الصور عالية الدقة والتعبير الإبداعي من Qwen Image خيارًا قويًا للمصممين والفنانين ومنشئي المحتوى الذين يبحثون عن صور عالية الجودة مُنشأة بالذكاء الاصطناعي.',
    
        // CTA Section
        ctaTitle: 'هل أنت مستعد للبدء في الإنشاء؟',
        ctaDescription: 'جرب Qwen Image الآن وحوّل أفكارك إلى صور مذهلة',
        ctaButton: 'جرب Qwen Image على 微鲤AI',
        ctaDisclaimer: 'لا حاجة لبطاقة ائتمان',
        },
    th: {
        // SEO Meta
        pageTitle: 'เครื่องมือสร้างภาพ AI Qwen Image - แปลงข้อความเป็นภาพฟรี',
        pageDescription: 'Qwen Image จาก Alibaba เป็นโมเดล AI แบบโอเพนซอร์สพื้นฐานที่โดดเด่นในการสร้างและแก้ไขภาพสไตล์ต่างๆ พร้อมการผสานข้อความที่ซับซ้อนอย่างยอดเยี่ยม ลอง Qwen Image ฟรีบนเครื่องมือสร้างภาพของ 微鲤AI!',
        pageKeywords: 'Qwen Image, Alibaba, การสร้างภาพด้วย AI, ศิลปะ AI, ปัญญาประดิษฐ์, การแก้ไขภาพ, การแสดงออกเชิงสร้างสรรค์',

        // Open Graph
        ogTitle: 'เครื่องมือสร้างภาพ AI Qwen Image - แปลงข้อความเป็นภาพฟรี',
        ogDescription: 'Qwen Image จาก Alibaba เป็นโมเดล AI แบบโอเพนซอร์สพื้นฐานที่โดดเด่นในการสร้างและแก้ไขภาพสไตล์ต่างๆ พร้อมการผสานข้อความที่ซับซ้อนอย่างยอดเยี่ยม',

        // Twitter Card
        twitterTitle: 'เครื่องมือสร้างภาพ AI Qwen Image - แปลงข้อความเป็นภาพฟรี',
        twitterDescription: 'Qwen Image จาก Alibaba โดดเด่นในการสร้างและแก้ไขภาพสไตล์ต่างๆ พร้อมการผสานข้อความที่ซับซ้อนอย่างยอดเยี่ยม',

        // Generator Section
        generatorTitle: 'เครื่องมือสร้างภาพ AI Qwen Image',
        generatorSubtitle: 'Qwen Image จาก Alibaba เป็นโมเดล AI แบบโอเพนซอร์สพื้นฐานที่โดดเด่นในการสร้างและแก้ไขภาพสไตล์ต่างๆ พร้อมการผสานข้อความที่ซับซ้อนอย่างยอดเยี่ยม ลอง Qwen Image ฟรีบนเครื่องมือสร้างภาพของ 微鲤AI!',

        // Core Features Section
        coreFeaturesTitle: 'คุณสมบัติเด่นของ Qwen Image',
        coreFeaturesSubtitle: 'สำรวจคุณสมบัติหลักของเครื่องมือสร้างภาพ AI Qwen Image และเริ่มต้นการสร้างภาพด้วย AI แบบใหม่',

        // Features
        diverseImageTitle: 'สร้างภาพหลากหลายสไตล์',
        diverseImageDesc: 'สร้างภาพที่มีชีวิตชีวาในหลากหลายสไตล์ Qwen Image สร้างภาพคุณภาพระดับมืออาชีพ รองรับสไตล์ศิลป์หลากหลายและการแสดงออกเชิงสร้างสรรค์ ขยายความคิดสร้างสรรค์ได้ไม่สิ้นสุด',
        diverseImageAlt: 'ตัวอย่างการสร้างภาพหลากหลายสไตล์',

        intuitiveEditingTitle: 'แก้ไขภาพแบบเข้าใจง่าย',
        intuitiveEditingDesc: 'รองรับการแก้ไขระดับมืออาชีพด้วยภาษาที่ใช้ในชีวิตประจำวัน ผ่านคำอธิบายสั้นๆ คุณสามารถปรับรายละเอียด สี สไตล์ และองค์ประกอบภาพได้อย่างแม่นยำโดยไม่ต้องทำขั้นตอนซับซ้อน',
        intuitiveEditingAlt: 'ตัวอย่างการแก้ไขภาพแบบเข้าใจง่าย',

        fineTextRenderingTitle: 'การเรนเดอร์ข้อความอย่างละเอียด',
        fineTextRenderingDesc: 'ผสานข้อความหลายภาษาเข้ากับภาพได้อย่างราบรื่น รองรับการเรนเดอร์ข้อความหลายภาษา ทำให้ข้อความและภาพผสานกันอย่างสมบูรณ์เพื่อสร้างเอฟเฟกต์ภาพระดับมืออาชีพ',
        fineTextRenderingAlt: 'ตัวอย่างการเรนเดอร์ข้อความอย่างละเอียด',

        smartPromptTitle: 'ทำตามพรอมป์ต์อย่างชาญฉลาด',
        smartPromptDesc: 'มีความเข้าใจภาพเชิงลึกเพื่อถ่ายทอดคำสั่งสร้างสรรค์ วิเคราะห์ความต้องการของคุณอย่างชาญฉลาด เข้าใจเจตนาสร้างสรรค์อย่างแม่นยำ และสร้างภาพคุณภาพสูงตามที่คาดหวัง',
        smartPromptAlt: 'ตัวอย่างทำตามพรอมป์ต์อย่างชาญฉลาด',

        // How to Use Section
        howToUseTitle: 'วิธีใช้งาน',
        howToUseSubtitle: 'สามขั้นตอนง่ายๆ เพื่อเริ่มสร้างสรรค์',

        step1Title: 'เลือกโมเดล',
        step1Description: 'เลือกโมเดล Qwen Image ในเครื่องมือภาพ AI',

        step2Title: 'ป้อนเนื้อหา',
        step2Description: 'กรอกพรอมป์ต์หรืออัปโหลดภาพอ้างอิง',

        step3Title: 'สร้างภาพ',
        step3Description: 'คลิกปุ่มสร้าง รอแล้วดาวน์โหลดภาพของคุณ',

        // YouTube Videos Section
        youtubeTitle: 'วิดีโอ YouTube เกี่ยวกับโมเดล AI Qwen Image',

        // X Posts Section
        xPostsTitle: 'โพสต์ X เกี่ยวกับโมเดล AI Qwen Image',

        // Explore Other Models Section
        exploreModelsTitle: 'สำรวจโมเดลสร้างภาพ AI อื่นๆ บน 微鲤AI',
        model1Title: 'เครื่องมือสร้างภาพ AI Google Nano Banana',
        model2Title: 'เครื่องมือสร้างภาพ AI FLUX',
        model3Title: 'เครื่องมือสร้างภาพ AI Google Imagen',

        // FAQ Section
        faqTitle: 'คำถามที่พบบ่อย',

        faq1Question: 'Qwen Image คืออะไร?',
        faq1Answer: 'Qwen Image คือโมเดลสร้างภาพด้วย AI แบบโอเพนซอร์สที่พัฒนาโดย Alibaba โดดเด่นด้วยคุณภาพภาพและความสามารถในการแสดงออกเชิงสร้างสรรค์ สามารถสร้างภาพระดับมืออาชีพได้',

        faq2Question: 'Qwen Image มีข้อได้เปรียบอะไรเหนือโมเดลสร้างภาพอื่น?',
        faq2Answer: 'Qwen Image โดดเด่นด้านคุณภาพภาพ การแสดงออกเชิงสร้างสรรค์ การควบคุมสไตล์ และการเรนเดอร์ข้อความ สามารถสร้างภาพคุณภาพสูงระดับมืออาชีพและรองรับการผสานข้อความที่ซับซ้อน',

        faq3Question: 'ฉันใช้ Qwen Image ฟรีได้ไหม?',
        faq3Answer: 'ได้ Qwen Image มีเครดิตฟรีแบบจำกัดผ่านช่วงทดลองฟรีของ 微鲤AI หากใช้งานมากจำเป็นต้องอัปเกรด',

        faq4Question: 'Qwen Image รองรับไฟล์ภาพรูปแบบใด?',
        faq4Answer: 'Qwen Image รองรับ JPG, PNG, WEBP และรูปแบบทั่วไปอื่นๆ ภาพที่สร้างมีคุณภาพสูงและรายละเอียดคมชัด',

        faq5Question: 'ฉันใช้ Qwen Image เพื่อโครงการเชิงพาณิชย์ได้ไหม?',
        faq5Answer: 'ได้ ความสามารถในการสร้างภาพความละเอียดสูงและการแสดงออกเชิงสร้างสรรค์ทำให้ Qwen Image เป็นตัวเลือกที่ทรงพลังสำหรับนักออกแบบ ศิลปิน และครีเอเตอร์ที่ต้องการภาพ AI คุณภาพสูง',

        // CTA Section
        ctaTitle: 'พร้อมเริ่มสร้างสรรค์แล้วหรือยัง?',
        ctaDescription: 'ลอง Qwen Image ตอนนี้และเปลี่ยนไอเดียของคุณให้เป็นภาพสุดน่าทึ่ง',
        ctaButton: 'ลอง Qwen Image บน 微鲤AI',
        ctaDisclaimer: 'ไม่ต้องใช้บัตรเครดิต',
        },
    da: {
        // SEO Meta
        pageTitle: 'Qwen Image AI-billedgenerator - Gratis tekst til billede',
        pageDescription: 'Qwen Image fra Alibaba er en grundlæggende open-source AI-model, der excellerer i at generere og redigere stiliserede billeder med fremragende kompleks tekstintegration. Prøv Qwen Image gratis på 微鲤AI-billedgeneratoren!',
        pageKeywords: 'Qwen Image, Alibaba, AI-billedgenerering, AI-kunst, kunstig intelligens, billedredigering, kreativt udtryk',

        // Open Graph
        ogTitle: 'Qwen Image AI-billedgenerator - Gratis tekst til billede',
        ogDescription: 'Qwen Image fra Alibaba er en grundlæggende open-source AI-model, der excellerer i at generere og redigere stiliserede billeder med fremragende kompleks tekstintegration.',

        // Twitter Card
        twitterTitle: 'Qwen Image AI-billedgenerator - Gratis tekst til billede',
        twitterDescription: 'Qwen Image fra Alibaba excellerer i at generere og redigere stiliserede billeder med fremragende kompleks tekstintegration.',

        // Generator Section
        generatorTitle: 'Qwen Image AI-billedgenerator',
        generatorSubtitle: 'Qwen Image fra Alibaba er en grundlæggende open-source AI-model, der excellerer i at generere og redigere stiliserede billeder med fremragende kompleks tekstintegration. Prøv Qwen Image gratis på 微鲤AI-billedgeneratoren!',

        // Core Features Section
        coreFeaturesTitle: 'Qwen Image kernefunktioner',
        coreFeaturesSubtitle: 'Udforsk kernefunktionerne i Qwen Image AI-billedgeneratoren og begynd en revolutionerende AI-billedskabelsesrejse',

        // Features
        diverseImageTitle: 'Alsidig billedgenerering',
        diverseImageDesc: 'Skab levende billeder i forskellige stilarter. Qwen Image genererer billeder i professionel kvalitet, understøtter flere kunstneriske stilarter og kreativt udtryk og udvider din kreativitet uendeligt.',
        diverseImageAlt: 'Eksempel på alsidig billedgenerering',

        intuitiveEditingTitle: 'Intuitiv billedredigering',
        intuitiveEditingDesc: 'Understøtter redigering på professionelt niveau med hverdagssprog. Med enkle tekstbeskrivelser kan du præcist justere billeddetaljer, farver, stilarter og komposition uden komplekse operationer.',
        intuitiveEditingAlt: 'Eksempel på intuitiv billedredigering',

        fineTextRenderingTitle: 'Finmasket tekstrendering',
        fineTextRenderingDesc: 'Integrer flersproget tekst problemfrit i billeder. Understøtter tekstrendering på flere sprog og sikrer perfekt sammensmeltning af tekst og billede for professionelle visuelle effekter.',
        fineTextRenderingAlt: 'Eksempel på finmasket tekstrendering',

        smartPromptTitle: 'Smart prompt-følgning',
        smartPromptDesc: 'Har dyb visuel forståelse til at realisere kreative instruktioner. Analyserer dine behov intelligent, forstår din kreative intention præcist og genererer højkvalitetsbilleder, der lever op til forventningerne.',
        smartPromptAlt: 'Eksempel på smart prompt-følgning',

        // How to Use Section
        howToUseTitle: 'Sådan bruges',
        howToUseSubtitle: 'Tre enkle trin til at komme i gang',

        step1Title: 'Vælg model',
        step1Description: 'Vælg Qwen Image-modellen i AI-billedværktøjer',

        step2Title: 'Indtast indhold',
        step2Description: 'Indtast prompts eller upload referencebilleder',

        step3Title: 'Generer billede',
        step3Description: 'Klik på generer-knappen, vent og download dit billede',

        // YouTube Videos Section
        youtubeTitle: 'YouTube-videoer om Qwen Image AI-modellen',

        // X Posts Section
        xPostsTitle: 'X-opslag om Qwen Image AI-modellen',

        // Explore Other Models Section
        exploreModelsTitle: 'Udforsk andre AI-billedmodeller på 微鲤AI',
        model1Title: 'Google Nano Banana AI-billedgenerator',
        model2Title: 'FLUX AI-billedgenerator',
        model3Title: 'Google Imagen AI-billedgenerator',

        // FAQ Section
        faqTitle: 'Ofte stillede spørgsmål',

        faq1Question: 'Hvad er Qwen Image?',
        faq1Answer: 'Qwen Image er en open-source AI-billedgenereringsmodel udviklet af Alibaba med enestående billedkvalitet og kreativt udtryk, der kan skabe billeder i professionel kvalitet.',

        faq2Question: 'Hvilke fordele har Qwen Image i forhold til andre billedgenereringsmodeller?',
        faq2Answer: 'Qwen Image har markante fordele i billedkvalitet, kreativt udtryk, stilkontrol og tekstrendering. Den kan generere professionelle billeder i høj kvalitet og understøtter kompleks tekstintegration.',

        faq3Question: 'Kan jeg bruge Qwen Image gratis?',
        faq3Answer: 'Ja. Qwen Image tilbyder begrænsede gratis credits via 微鲤AI\'s gratis prøveperiode. Til omfattende brug kræves opgradering.',

        faq4Question: 'Hvilke billedformater understøtter Qwen Image?',
        faq4Answer: 'Qwen Image understøtter forskellige billedformater, herunder JPG, PNG, WEBP og andre almindelige formater. Genererede billeder har høj kvalitet og rige detaljer.',

        faq5Question: 'Kan jeg bruge Qwen Image til kommercielle projekter?',
        faq5Answer: 'Ja. Qwen Images højpræcise billedgenerering og kreative udtryk gør den til et stærkt valg for designere, kunstnere og indholdsskabere, der ønsker AI-genererede billeder i høj kvalitet.',

        // CTA Section
        ctaTitle: 'Klar til at skabe?',
        ctaDescription: 'Prøv Qwen Image nu og forvandl dine ideer til fantastiske billeder',
        ctaButton: 'Prøv Qwen Image på 微鲤AI',
        ctaDisclaimer: 'Intet kreditkort kræves',
        },
    no: {
        // SEO Meta
        pageTitle: 'Qwen Image AI-bildegenerator - Gratis tekst til bilde',
        pageDescription: 'Qwen Image fra Alibaba er en grunnleggende open-source AI-modell som utmerker seg i å generere og redigere stiliserte bilder med fremragende kompleks tekstintegrasjon. Prøv Qwen Image gratis på 微鲤AI-bildegeneratoren!',
        pageKeywords: 'Qwen Image, Alibaba, AI-bildegenerering, AI-kunst, kunstig intelligens, bilderedigering, kreativt uttrykk',

        // Open Graph
        ogTitle: 'Qwen Image AI-bildegenerator - Gratis tekst til bilde',
        ogDescription: 'Qwen Image fra Alibaba er en grunnleggende open-source AI-modell som utmerker seg i å generere og redigere stiliserte bilder med fremragende kompleks tekstintegrasjon.',

        // Twitter Card
        twitterTitle: 'Qwen Image AI-bildegenerator - Gratis tekst til bilde',
        twitterDescription: 'Qwen Image fra Alibaba utmerker seg i å generere og redigere stiliserte bilder med fremragende kompleks tekstintegrasjon.',

        // Generator Section
        generatorTitle: 'Qwen Image AI-bildegenerator',
        generatorSubtitle: 'Qwen Image fra Alibaba er en grunnleggende open-source AI-modell som utmerker seg i å generere og redigere stiliserte bilder med fremragende kompleks tekstintegrasjon. Prøv Qwen Image gratis på 微鲤AI-bildegeneratoren!',

        // Core Features Section
        coreFeaturesTitle: 'Kjernefunksjoner i Qwen Image',
        coreFeaturesSubtitle: 'Utforsk kjernefunksjonene i Qwen Image AI-bildegenerator og start en revolusjonerende AI-bildekreasjonsreise',

        // Features
        diverseImageTitle: 'Mangfoldig bildegenerering',
        diverseImageDesc: 'Lag livaktige bilder i ulike stiler. Qwen Image genererer bilder i profesjonell kvalitet, støtter flere kunstneriske stiler og kreativt uttrykk, og utvider kreativiteten din uendelig.',
        diverseImageAlt: 'Eksempel på mangfoldig bildegenerering',

        intuitiveEditingTitle: 'Intuitiv bilderedigering',
        intuitiveEditingDesc: 'Støtter redigering på profesjonelt nivå med dagligspråk. Med enkle tekstbeskrivelser kan du presist justere bildedetaljer, farger, stiler og komposisjon uten kompliserte operasjoner.',
        intuitiveEditingAlt: 'Eksempel på intuitiv bilderedigering',

        fineTextRenderingTitle: 'Finjustert tekstrendering',
        fineTextRenderingDesc: 'Integrer flerspråklig tekst sømløst i bilder. Støtter tekstrendering på flere språk og sikrer perfekt sammensmelting av tekst og bilde for profesjonelle visuelle effekter.',
        fineTextRenderingAlt: 'Eksempel på finjustert tekstrendering',

        smartPromptTitle: 'Smart prompt-følging',
        smartPromptDesc: 'Har dyp visuell forståelse for å realisere kreative instruksjoner. Analyserer behovene dine intelligent, forstår kreativ intensjon presist og genererer høykvalitetsbilder som møter forventningene.',
        smartPromptAlt: 'Eksempel på smart prompt-følging',

        // How to Use Section
        howToUseTitle: 'Slik bruker du',
        howToUseSubtitle: 'Tre enkle trinn for å komme i gang',

        step1Title: 'Velg modell',
        step1Description: 'Velg Qwen Image-modellen i AI-bildeverktøy',

        step2Title: 'Skriv inn innhold',
        step2Description: 'Skriv inn prompts eller last opp referansebilder',

        step3Title: 'Generer bilde',
        step3Description: 'Klikk på generer-knappen, vent og last ned bildet ditt',

        // YouTube Videos Section
        youtubeTitle: 'YouTube-videoer om Qwen Image AI-modellen',

        // X Posts Section
        xPostsTitle: 'X-innlegg om Qwen Image AI-modellen',

        // Explore Other Models Section
        exploreModelsTitle: 'Utforsk andre AI-bildemodeller på 微鲤AI',
        model1Title: 'Google Nano Banana AI-bildegenerator',
        model2Title: 'FLUX AI-bildegenerator',
        model3Title: 'Google Imagen AI-bildegenerator',

        // FAQ Section
        faqTitle: 'Ofte stilte spørsmål',

        faq1Question: 'Hva er Qwen Image?',
        faq1Answer: 'Qwen Image er en open-source AI-bildegenereringsmodell utviklet av Alibaba, med eksepsjonell bildekvalitet og kreativt uttrykk som kan generere bilder i profesjonell kvalitet.',

        faq2Question: 'Hvilke fordeler har Qwen Image sammenlignet med andre bildegenereringsmodeller?',
        faq2Answer: 'Qwen Image har store fordeler i bildekvalitet, kreativt uttrykk, stilkontroll og tekstrendering. Den kan generere profesjonelle bilder i høy kvalitet og støtter kompleks tekstintegrasjon.',

        faq3Question: 'Kan jeg bruke Qwen Image gratis?',
        faq3Answer: 'Ja. Qwen Image tilbyr begrensede gratis kreditter gjennom WeryAIs gratis prøveperiode. For omfattende bruk kreves oppgradering.',

        faq4Question: 'Hvilke bildeformater støtter Qwen Image?',
        faq4Answer: 'Qwen Image støtter ulike bildeformater, inkludert JPG, PNG, WEBP og andre vanlige formater. Genererte bilder har høy kvalitet og rike detaljer.',

        faq5Question: 'Kan jeg bruke Qwen Image til kommersielle prosjekter?',
        faq5Answer: 'Ja. Qwen Images høypresise bildegenerering og kreative uttrykk gjør den til et sterkt valg for designere, kunstnere og innholdsskapere som ønsker AI-genererte bilder av høy kvalitet.',

        // CTA Section
        ctaTitle: 'Klar til å skape?',
        ctaDescription: 'Prøv Qwen Image nå og gjør ideene dine om til fantastiske bilder',
        ctaButton: 'Prøv Qwen Image på 微鲤AI',
        ctaDisclaimer: 'Ingen kredittkort kreves',
        },
    nl: {
        // SEO Meta
        pageTitle: 'Qwen Image AI-beeldgenerator - Gratis tekst-naar-beeld',
        pageDescription: 'Qwen Image van Alibaba is een fundamenteel open-source AI-model dat uitblinkt in het genereren en bewerken van gestileerde beelden met uitstekende complexe tekstintegratie. Probeer Qwen Image gratis op de 微鲤AI-beeldgenerator!',
        pageKeywords: 'Qwen Image, Alibaba, AI-beeldgeneratie, AI-kunst, kunstmatige intelligentie, beeldbewerking, creatieve expressie',

        // Open Graph
        ogTitle: 'Qwen Image AI-beeldgenerator - Gratis tekst-naar-beeld',
        ogDescription: 'Qwen Image van Alibaba is een fundamenteel open-source AI-model dat uitblinkt in het genereren en bewerken van gestileerde beelden met uitstekende complexe tekstintegratie.',

        // Twitter Card
        twitterTitle: 'Qwen Image AI-beeldgenerator - Gratis tekst-naar-beeld',
        twitterDescription: 'Qwen Image van Alibaba blinkt uit in het genereren en bewerken van gestileerde beelden met uitstekende complexe tekstintegratie.',

        // Generator Section
        generatorTitle: 'Qwen Image AI-beeldgenerator',
        generatorSubtitle: 'Qwen Image van Alibaba is een fundamenteel open-source AI-model dat uitblinkt in het genereren en bewerken van gestileerde beelden met uitstekende complexe tekstintegratie. Probeer Qwen Image gratis op de 微鲤AI-beeldgenerator!',

        // Core Features Section
        coreFeaturesTitle: 'Kernfuncties van Qwen Image',
        coreFeaturesSubtitle: 'Ontdek de kernfuncties van de Qwen Image AI-beeldgenerator en begin aan een revolutionaire AI-beeldcreatiereis',

        // Features
        diverseImageTitle: 'Divers beeldgeneratie',
        diverseImageDesc: 'Maak levendige beelden in verschillende stijlen. Qwen Image genereert beelden van professionele kwaliteit, ondersteunt meerdere artistieke stijlen en creatieve expressie en vergroot je creativiteit eindeloos.',
        diverseImageAlt: 'Voorbeeld van diverse beeldgeneratie',

        intuitiveEditingTitle: 'Intuitieve beeldbewerking',
        intuitiveEditingDesc: 'Ondersteunt bewerken op professioneel niveau met alledaagse taal. Met eenvoudige tekstbeschrijvingen kun je beelddetails, kleuren, stijlen en compositie precies aanpassen zonder complexe handelingen.',
        intuitiveEditingAlt: 'Voorbeeld van intuïtieve beeldbewerking',

        fineTextRenderingTitle: 'Fijne tekstrendering',
        fineTextRenderingDesc: 'Integreer meertalige tekst naadloos in beelden. Ondersteunt tekstrendering in verschillende talen en zorgt voor een perfecte samensmelting van tekst en beeld voor professionele visuele effecten.',
        fineTextRenderingAlt: 'Voorbeeld van fijne tekstrendering',

        smartPromptTitle: 'Slimme prompt-volging',
        smartPromptDesc: 'Beschikt over diep visueel begrip om creatieve instructies te realiseren. Analyseert je behoeften intelligent, begrijpt de creatieve intentie nauwkeurig en genereert hoogwaardige beelden die aan de verwachtingen voldoen.',
        smartPromptAlt: 'Voorbeeld van slimme prompt-volging',

        // How to Use Section
        howToUseTitle: 'Hoe te gebruiken',
        howToUseSubtitle: 'Drie eenvoudige stappen om te starten',

        step1Title: 'Selecteer model',
        step1Description: 'Kies het Qwen Image-model in AI-beeldtools',

        step2Title: 'Voer inhoud in',
        step2Description: 'Voer prompts in of upload referentiebeelden',

        step3Title: 'Genereer beeld',
        step3Description: 'Klik op de genereerknop, wacht en download je beeld',

        // YouTube Videos Section
        youtubeTitle: 'YouTube-video\'s over het Qwen Image AI-model',

        // X Posts Section
        xPostsTitle: 'X-posts over het Qwen Image AI-model',

        // Explore Other Models Section
        exploreModelsTitle: 'Ontdek andere AI-beeldmodellen op 微鲤AI',
        model1Title: 'Google Nano Banana AI-beeldgenerator',
        model2Title: 'FLUX AI-beeldgenerator',
        model3Title: 'Google Imagen AI-beeldgenerator',

        // FAQ Section
        faqTitle: 'Veelgestelde vragen',

        faq1Question: 'Wat is Qwen Image?',
        faq1Answer: 'Qwen Image is een open-source AI-beeldgeneratiemodel ontwikkeld door Alibaba, met uitzonderlijke beeldkwaliteit en creatieve expressie om beelden van professionele kwaliteit te maken.',

        faq2Question: 'Welke voordelen heeft Qwen Image ten opzichte van andere beeldgeneratiemodellen?',
        faq2Answer: 'Qwen Image heeft grote voordelen in beeldkwaliteit, creatieve expressie, stijlcontrole en tekstrendering. Het kan professionele beelden van hoge kwaliteit genereren en ondersteunt complexe tekstintegratie.',

        faq3Question: 'Kan ik Qwen Image gratis gebruiken?',
        faq3Answer: 'Ja. Qwen Image biedt beperkte gratis credits via de gratis proefperiode van 微鲤AI. Voor intensief gebruik is een upgrade vereist.',

        faq4Question: 'Welke beeldformaten ondersteunt Qwen Image?',
        faq4Answer: 'Qwen Image ondersteunt diverse beeldformaten, waaronder JPG, PNG, WEBP en andere gangbare formaten. Gegenereerde beelden hebben hoge kwaliteit en rijke details.',

        faq5Question: 'Kan ik Qwen Image gebruiken voor commerciële projecten?',
        faq5Answer: 'Ja. De hoge-precisie beeldgeneratie en creatieve expressie van Qwen Image maken het een sterke keuze voor ontwerpers, kunstenaars en contentmakers die AI-gegenereerde beelden van hoge kwaliteit zoeken.',

        // CTA Section
        ctaTitle: 'Klaar om te creëren?',
        ctaDescription: 'Probeer Qwen Image nu en transformeer je ideeën in geweldige beelden',
        ctaButton: 'Probeer Qwen Image op 微鲤AI',
        ctaDisclaimer: 'Geen creditcard nodig',
        },
    id: {
        // SEO Meta
        pageTitle: 'Generator Gambar AI Qwen Image - Teks ke Gambar Gratis',
        pageDescription: 'Qwen Image dari Alibaba adalah model AI open-source dasar yang unggul dalam menghasilkan dan mengedit gambar bergaya dengan integrasi teks kompleks yang luar biasa. Coba Qwen Image gratis di generator gambar 微鲤AI!',
        pageKeywords: 'Qwen Image, Alibaba, pembuatan gambar AI, seni AI, kecerdasan buatan, pengeditan gambar, ekspresi kreatif',

        // Open Graph
        ogTitle: 'Generator Gambar AI Qwen Image - Teks ke Gambar Gratis',
        ogDescription: 'Qwen Image dari Alibaba adalah model AI open-source dasar yang unggul dalam menghasilkan dan mengedit gambar bergaya dengan integrasi teks kompleks yang luar biasa.',

        // Twitter Card
        twitterTitle: 'Generator Gambar AI Qwen Image - Teks ke Gambar Gratis',
        twitterDescription: 'Qwen Image dari Alibaba unggul dalam menghasilkan dan mengedit gambar bergaya dengan integrasi teks kompleks yang luar biasa.',

        // Generator Section
        generatorTitle: 'Generator Gambar AI Qwen Image',
        generatorSubtitle: 'Qwen Image dari Alibaba adalah model AI open-source dasar yang unggul dalam menghasilkan dan mengedit gambar bergaya dengan integrasi teks kompleks yang luar biasa. Coba Qwen Image gratis di generator gambar 微鲤AI!',

        // Core Features Section
        coreFeaturesTitle: 'Fitur Inti Qwen Image',
        coreFeaturesSubtitle: 'Jelajahi fitur inti generator gambar AI Qwen Image dan mulailah perjalanan kreasi gambar AI yang revolusioner',

        // Features
        diverseImageTitle: 'Generasi gambar beragam',
        diverseImageDesc: 'Buat gambar hidup dalam berbagai gaya. Qwen Image menghasilkan gambar berkualitas profesional, mendukung banyak gaya artistik dan ekspresi kreatif, memperluas kreativitas Anda tanpa batas.',
        diverseImageAlt: 'Contoh generasi gambar beragam',

        intuitiveEditingTitle: 'Pengeditan gambar intuitif',
        intuitiveEditingDesc: 'Mendukung pengeditan tingkat profesional dengan bahasa sehari-hari. Dengan deskripsi teks sederhana, Anda dapat menyesuaikan detail gambar, warna, gaya, dan komposisi secara presisi tanpa operasi rumit.',
        intuitiveEditingAlt: 'Contoh pengeditan gambar intuitif',

        fineTextRenderingTitle: 'Perenderan teks yang detail',
        fineTextRenderingDesc: 'Mengintegrasikan teks multibahasa ke dalam gambar secara mulus. Mendukung perenderan teks dalam berbagai bahasa, memastikan perpaduan sempurna antara teks dan gambar untuk efek visual profesional.',
        fineTextRenderingAlt: 'Contoh perenderan teks yang detail',

        smartPromptTitle: 'Mengikuti prompt cerdas',
        smartPromptDesc: 'Memiliki pemahaman visual yang mendalam untuk mewujudkan instruksi kreatif. Menganalisis kebutuhan Anda secara cerdas, memahami niat kreatif dengan tepat, dan menghasilkan gambar berkualitas tinggi sesuai harapan.',
        smartPromptAlt: 'Contoh mengikuti prompt cerdas',

        // How to Use Section
        howToUseTitle: 'Cara menggunakan',
        howToUseSubtitle: 'Tiga langkah sederhana untuk mulai berkarya',

        step1Title: 'Pilih model',
        step1Description: 'Pilih model Qwen Image di alat gambar AI',

        step2Title: 'Masukkan konten',
        step2Description: 'Masukkan prompt atau unggah gambar referensi',

        step3Title: 'Hasilkan gambar',
        step3Description: 'Klik tombol generate, tunggu, lalu unduh gambar Anda',

        // YouTube Videos Section
        youtubeTitle: 'Video YouTube tentang model AI Qwen Image',

        // X Posts Section
        xPostsTitle: 'Postingan X tentang model AI Qwen Image',

        // Explore Other Models Section
        exploreModelsTitle: 'Jelajahi model gambar AI lainnya di 微鲤AI',
        model1Title: 'Generator Gambar AI Google Nano Banana',
        model2Title: 'Generator Gambar AI FLUX',
        model3Title: 'Generator Gambar AI Google Imagen',

        // FAQ Section
        faqTitle: 'Pertanyaan yang sering diajukan',

        faq1Question: 'Apa itu Qwen Image?',
        faq1Answer: 'Qwen Image adalah model pembuatan gambar AI open-source yang dikembangkan oleh Alibaba, dengan kualitas gambar luar biasa dan kemampuan ekspresi kreatif untuk menghasilkan gambar berkelas profesional.',

        faq2Question: 'Apa keunggulan Qwen Image dibanding model pembuatan gambar lainnya?',
        faq2Answer: 'Qwen Image memiliki keunggulan besar dalam kualitas gambar, ekspresi kreatif, kontrol gaya, dan perenderan teks. Model ini dapat menghasilkan gambar profesional berkualitas tinggi dan mendukung integrasi teks yang kompleks.',

        faq3Question: 'Bisakah saya menggunakan Qwen Image gratis?',
        faq3Answer: 'Ya. Qwen Image menawarkan kredit gratis terbatas melalui uji coba gratis 微鲤AI. Untuk penggunaan yang ekstensif, diperlukan peningkatan.',

        faq4Question: 'Format gambar apa yang didukung Qwen Image?',
        faq4Answer: 'Qwen Image mendukung berbagai format gambar termasuk JPG, PNG, WEBP, dan format umum lainnya. Gambar yang dihasilkan memiliki kualitas tinggi dan detail yang kaya.',

        faq5Question: 'Bisakah saya menggunakan Qwen Image untuk proyek komersial?',
        faq5Answer: 'Ya. Kemampuan generasi gambar presisi tinggi dan ekspresi kreatif Qwen Image menjadikannya pilihan kuat bagi desainer, seniman, dan kreator konten yang mencari gambar AI berkualitas tinggi.',

        // CTA Section
        ctaTitle: 'Siap mulai berkarya?',
        ctaDescription: 'Coba Qwen Image sekarang dan ubah ide Anda menjadi gambar yang menakjubkan',
        ctaButton: 'Coba Qwen Image di 微鲤AI',
        ctaDisclaimer: 'Tidak perlu kartu kredit',
        },
    tr: {
        // SEO Meta
        pageTitle: 'Qwen Image AI Görsel Üretici - Ücretsiz Metinden Görsele',
        pageDescription: 'Alibaba\'nın Qwen Image modeli, etkileyici karmaşık metin entegrasyonuyla stilize görseller üretme ve düzenlemede öne çıkan temel bir açık kaynak AI modelidir. 微鲤AI görsel üreticisinde Qwen Image\'i ücretsiz deneyin!',
        pageKeywords: 'Qwen Image, Alibaba, AI görsel üretimi, AI sanatı, yapay zeka, görsel düzenleme, yaratıcı ifade',

        // Open Graph
        ogTitle: 'Qwen Image AI Görsel Üretici - Ücretsiz Metinden Görsele',
        ogDescription: 'Alibaba\'nın Qwen Image modeli, etkileyici karmaşık metin entegrasyonuyla stilize görseller üretme ve düzenlemede öne çıkan temel bir açık kaynak AI modelidir.',

        // Twitter Card
        twitterTitle: 'Qwen Image AI Görsel Üretici - Ücretsiz Metinden Görsele',
        twitterDescription: 'Alibaba\'nın Qwen Image modeli, etkileyici karmaşık metin entegrasyonuyla stilize görseller üretme ve düzenlemede öne çıkar.',

        // Generator Section
        generatorTitle: 'Qwen Image AI Görsel Üretici',
        generatorSubtitle: 'Alibaba\'nın Qwen Image modeli, etkileyici karmaşık metin entegrasyonuyla stilize görseller üretme ve düzenlemede öne çıkan temel bir açık kaynak AI modelidir. 微鲤AI görsel üreticisinde Qwen Image\'i ücretsiz deneyin!',

        // Core Features Section
        coreFeaturesTitle: 'Qwen Image Temel Özellikleri',
        coreFeaturesSubtitle: 'Qwen Image AI görsel üreticisinin temel özelliklerini keşfedin ve devrim niteliğinde bir AI görsel oluşturma yolculuğuna başlayın',

        // Features
        diverseImageTitle: 'Çeşitli görsel üretimi',
        diverseImageDesc: 'Farklı stillerde canlı görseller oluşturun. Qwen Image, profesyonel kalitede görseller üretir, birden çok sanatsal stili ve yaratıcı ifadeyi destekler, yaratıcılığınızı sınırsızca genişletir.',
        diverseImageAlt: 'Çeşitli görsel üretimi örneği',

        intuitiveEditingTitle: 'Sezgisel görsel düzenleme',
        intuitiveEditingDesc: 'Günlük dili kullanarak profesyonel düzeyde düzenleme desteği sunar. Basit metin açıklamalarıyla görsel ayrıntılarını, renkleri, stilleri ve kompozisyonu karmaşık işlemler olmadan hassas biçimde ayarlayabilirsiniz.',
        intuitiveEditingAlt: 'Sezgisel görsel düzenleme örneği',

        fineTextRenderingTitle: 'İnce ayrıntılı metin işleme',
        fineTextRenderingDesc: 'Çok dilli metni görsellere sorunsuzca entegre eder. Birçok dilde metin işleme desteğiyle metin ve görselin kusursuz birleşimini sağlayarak profesyonel görsel efektler oluşturur.',
        fineTextRenderingAlt: 'İnce ayrıntılı metin işleme örneği',

        smartPromptTitle: 'Akıllı istem takibi',
        smartPromptDesc: 'Yaratıcı talimatları gerçekleştirmek için derin görsel anlayışa sahiptir. İhtiyaçlarınızı akıllıca analiz eder, yaratıcı niyeti doğru anlar ve beklentileri karşılayan yüksek kaliteli görseller üretir.',
        smartPromptAlt: 'Akıllı istem takibi örneği',

        // How to Use Section
        howToUseTitle: 'Nasıl kullanılır',
        howToUseSubtitle: 'Başlamak için üç basit adım',

        step1Title: 'Model seçin',
        step1Description: 'AI görsel araçlarında Qwen Image modelini seçin',

        step2Title: 'İçerik girin',
        step2Description: 'İstemleri girin veya referans görseller yükleyin',

        step3Title: 'Görsel oluşturun',
        step3Description: 'Oluştur düğmesine tıklayın, bekleyin ve görselinizi indirin',

        // YouTube Videos Section
        youtubeTitle: 'Qwen Image AI modeli hakkında YouTube videoları',

        // X Posts Section
        xPostsTitle: 'Qwen Image AI modeli hakkında X gönderileri',

        // Explore Other Models Section
        exploreModelsTitle: '微鲤AI\'de diğer AI görsel modellerini keşfedin',
        model1Title: 'Google Nano Banana AI Görsel Üretici',
        model2Title: 'FLUX AI Görsel Üretici',
        model3Title: 'Google Imagen AI Görsel Üretici',

        // FAQ Section
        faqTitle: 'Sıkça sorulan sorular',

        faq1Question: 'Qwen Image nedir?',
        faq1Answer: 'Qwen Image, Alibaba tarafından geliştirilen açık kaynaklı bir AI görsel üretim modelidir; olağanüstü görsel kalitesi ve yaratıcı ifade yetenekleriyle profesyonel düzeyde görseller üretebilir.',

        faq2Question: 'Qwen Image\'in diğer görsel üretim modellerine göre avantajları nelerdir?',
        faq2Answer: 'Qwen Image, görsel kalitesi, yaratıcı ifade, stil kontrolü ve metin işleme alanlarında önemli avantajlara sahiptir. Yüksek kaliteli profesyonel görseller üretebilir ve karmaşık metin entegrasyonunu destekler.',

        faq3Question: 'Qwen Image\'i ücretsiz kullanabilir miyim?',
        faq3Answer: 'Evet. Qwen Image, 微鲤AI\'nin ücretsiz denemesiyle sınırlı ücretsiz kredi sunar. Yoğun kullanım için yükseltme gerekir.',

        faq4Question: 'Qwen Image hangi görsel formatlarını destekler?',
        faq4Answer: 'Qwen Image, JPG, PNG, WEBP ve diğer yaygın formatlar dahil çeşitli görsel formatlarını destekler. Üretilen görseller yüksek kalite ve zengin ayrıntılar sunar.',

        faq5Question: 'Qwen Image\'i ticari projelerde kullanabilir miyim?',
        faq5Answer: 'Evet. Qwen Image\'in yüksek hassasiyetli görsel üretimi ve yaratıcı ifade yetenekleri, yüksek kaliteli AI görselleri arayan tasarımcılar, sanatçılar ve içerik üreticileri için güçlü bir seçenektir.',

        // CTA Section
        ctaTitle: 'Oluşturmaya hazır mısınız?',
        ctaDescription: 'Qwen Image\'i şimdi deneyin ve fikirlerinizi harika görsellere dönüştürün',
        ctaButton: '微鲤AI\'de Qwen Image\'i deneyin',
        ctaDisclaimer: 'Kredi kartı gerekmez',
        },
}
